<template>
    <div class="radio__item" :class="{'isBE' : isBE, 'isNCH': isNCH }" v-if="isMeetingRoomVisible">
        <!-- Default input, which is hidden -->
    <input type="radio" :id="'room_' + id" name="radios" value="" class="b radio__input" @change="setSelectedRoom(id, position)" :checked="isRoomSelected(id)">
        <!-- Content (this needs to be right after radio input for the styles to work properly-->

        <label :for="'room_' + id" class="radio__content">

        <div class="radio__main">

        <!-- Tiny image carousel full screen carousel on click -->

        <div class="tiny-carousel radio__carousel carousel-toggle" :class="{'no-image': checkImage}" @click="openRoomLightBox(0)" :style="{ backgroundImage: `url('${image[0]}')` }">
        </div>
        <div v-if="show360Modal" class="video__container_360" style="height:100%;">
        <ModalComponent v-if="show360Modal" @close="show360Modal = false">
            <div slot="header"></div>
            <div slot="body" class="video360ModalBody">
            <div style="margin:0px;padding:0px;overflow:hidden;height:100%;">
                <iframe :src="threeSixtyView" frameborder="0" style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:150%;width:150%;position:absolute;top:0px;left:0px;right:0px;bottom:0px" height="150%" width="150%"></iframe>
            </div>
            </div>
            <div slot="footer">
            <button style="background-color: #0055a9;position:absolute;top:unset!important;bottom:10px;" type="button" title="Close (Esc)" class="modal-default-button vue-lb-button-close threeSixtyCloseBtn" @click="show360Modal = false">
                        <span>
                        <svg fill="white" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 512 512">
                            <path d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4 L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1 c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1 c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"></path>
                        </svg>
                        </span>
            </button>
            </div>
        </ModalComponent>
        </div>

        <!-- Title -->

        <div class="radio__head" :class="{'radio_head__be': isBE, 'radio_head_disabled': (available == 0 || exceed == 'yes' || !valid_layout)}">

            <h2 class="radio__title">{{ title }} <br> <span class="ribbon ribbon--with-icon"
            v-if="instantBookable == '1' && !(available == 0 || exceed == 'yes' || !valid_layout || notNumericMT || chosenPriceType == 'none')"
            ><img src="../assets/img/icon-flash.svg" alt="Instant Bookable Icon" class="ribbon__img" width="8" height="14"> {{ strings.availableImmediately }}</span></h2>
            <!-- Meta information -->
                <p v-if="isSmartSpace && currentTab == 'room'" style="font-size:14px;padding-right:5px;">
                    {{strings.the}} <b style="color: #dd2c00;">{{strings.minimumSpend}}</b> {{strings.toBookThis}} {{ currencySymbol }} <strong>{{minRevenue.toFixed(2)}}</strong>. {{strings.youCanAddFood}}
                </p>
                <p v-if="isSmartSpace && currentTab == 'package'" style="font-size:14px;padding-right:5px;">
                    {{strings.the}} <b style="color: #dd2c00;">{{strings.minimumSpend}}</b> {{strings.ofDelegatesToBookThis}} <strong>{{roomMin}}</strong>. {{strings.youCanAddFood}}
                </p>
            <a class="radio__link js-radio-open-details threesixtyLink" v-if="threeSixtyView && threeSixtyView != 'null'&& isBE"  @click="show360Modal = true" >{{strings.threeSixtyView}}</a>

            <!-- Top 5 equipments list -->
            <ul v-if="!isRegus" class="checklist equipmentList">
                <li v-show="!isOpera || roomEquipment.includes(item)" v-for="(item,key) in roomEquipment.slice(0, 5)" class="checklist__item top_equipments-item" :class="{'checklist__item--not-available': !roomEquipment.includes(item) }" :key="key">{{ item }}</li>
            </ul>

            <a  v-if="showDetailsToggle" href="" class="radio__link js-radio-open-details" @click.prevent="toggleDetails()">{{ isHidden ? strings.showdetails : strings.hidedetails }}</a>
        </div>


        <!-- Seating order -->
        <div v-if="!isRegus" class="radio__single-detail new_seating_order" :class="{'new_seating_order_disabled': (available == 0 || exceed == 'yes' || !valid_layout)}" v-show="isBE">
              <h4 class="no-border-bottom seating_order-title" v-show="!no_layout">{{ strings.seatingorder }}</h4>
              <!-- Seating layout in room -->
              <ul class="seating-list">
                  <li @click="chooseLayout(403, roomLayout.cocktail)" class="seating-list__item" v-tooltip.top-center="strings.layouts['403']" v-if="layoutEnabled('cocktail')"  :class="{'seating-list__item--not-available' : roomLayout.cocktail == null || isExceeded(roomLayout.cocktail), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['cocktail']}" >
                      <img src="../assets/img/seating-cocktail.png" height="20" width="20" alt="Cocktail Layout Icon">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('cocktail')}">{{ roomLayoutOriginal.cocktail != null ? roomLayoutOriginal.cocktail : '-' }}</p>
                        <p v-if="isCapacityReduced('cocktail')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.cocktail != null ? roomLayout.cocktail : '-' }}</p>
                      </div>
                  </li>
                  <li @click="chooseLayout(405, roomLayout.ushape)" class="seating-list__item" v-tooltip.top-center="strings.layouts['405']" v-if="layoutEnabled('ushape')"  :class="{'seating-list__item--not-available' : roomLayout.ushape == null || isExceeded(roomLayout.ushape), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['ushape']}" >
                      <img src="../assets/img/seating-ushape.png" height="20" width="20" alt="Ushape Layout Icon">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('ushape')}">{{ roomLayoutOriginal.ushape != null ? roomLayoutOriginal.ushape : '-' }}</p>
                        <p v-if="isCapacityReduced('ushape')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.ushape != null ? roomLayout.ushape : '-' }}</p>
                      </div>
                  </li>
                  <li @click="chooseLayout(400, roomLayout.boardroom)" class="seating-list__item" v-tooltip.top-center="strings.layouts['400']" v-if="layoutEnabled('boardroom')"  :class="{'seating-list__item--not-available' : roomLayout.boardroom == null || isExceeded(roomLayout.boardroom), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['boardroom']}" >
                      <img src="../assets/img/seating-boardroom.png" height="20" width="20" alt="Boardroom Layout Icon">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('boardroom')}">{{ roomLayoutOriginal.boardroom != null ? roomLayoutOriginal.boardroom : '-' }}</p>
                        <p v-if="isCapacityReduced('boardroom')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.boardroom != null ? roomLayout.boardroom : '-' }}</p>
                      </div>
                  </li>
                  <li @click="chooseLayout(404, roomLayout.theater)" class="seating-list__item" v-tooltip.top-center="strings.layouts['404']" v-if="layoutEnabled('theater')" :class="{'seating-list__item--not-available' : roomLayout.theater == null || isExceeded(roomLayout.theater), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['theater']}" >
                      <img src="../assets/img/seating-theater.png" height="20" width="20" alt="Theater Layout Icon">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('theater')}">{{ roomLayoutOriginal.theater != null ? roomLayoutOriginal.theater : '-' }}</p>
                        <p v-if="isCapacityReduced('theater')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.theater != null ? roomLayout.theater : '-' }}</p>
                      </div>
                  </li>
                  <li @click="chooseLayout(402,roomLayout.classroom)" class="seating-list__item" v-tooltip.top-center="strings.layouts['402']" v-if="layoutEnabled('classroom')"  :class="{'seating-list__item--not-available' : roomLayout.classroom == null || isExceeded(roomLayout.classroom), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['classroom']}" >
                      <img src="../assets/img/seating-classroom.png" height="20" width="20" alt="Classroom Layout Icon">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('classroom')}">{{ roomLayoutOriginal.classroom != null ? roomLayoutOriginal.classroom : '-' }}</p>
                        <p v-if="isCapacityReduced('classroom')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.classroom != null ? roomLayout.classroom : '-' }}</p>
                      </div>
                  </li>
                  <li @click="chooseLayout(399, roomLayout.banquet)" class="seating-list__item" v-tooltip.top-center="strings.layouts['399']" v-if="layoutEnabled('banquet')" :class="{'seating-list__item--not-available' : roomLayout.banquet == null || isExceeded(roomLayout.banquet), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['banquet']}" >
                      <img src="../assets/img/seating-banquet.png" height="20" width="20" alt="Banquet Layout Icon">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('banquet')}">{{ roomLayoutOriginal.banquet != null ? roomLayoutOriginal.banquet : '-' }}</p>
                        <p v-if="isCapacityReduced('banquet')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.banquet != null ? roomLayout.banquet : '-' }}</p>
                      </div>
                  </li>
                  <li @click="chooseLayout(401,roomLayout.cabaret)" class="seating-list__item" v-tooltip.top-center="strings.layouts['401']" v-if="layoutEnabled('cabaret') && !isNCH" :class="{'seating-list__item--not-available' : roomLayout.cabaret == null || isExceeded(roomLayout.cabaret), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['cabaret']}" >
                      <img src="../assets/img/seating-cabaret.png" height="20" width="20" alt="Cabaret Layout Icon">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('cabaret')}">{{ roomLayoutOriginal.cabaret != null ? roomLayoutOriginal.cabaret : '-' }}</p>
                        <p v-if="isCapacityReduced('cabaret')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.cabaret != null ? roomLayout.cabaret : '-' }}</p>
                      </div>
                  </li>
                  <li @click="chooseLayout(760,roomLayout.island)" class="seating-list__item" v-tooltip.top-center="strings.layouts['760']" v-if="layoutEnabled('island')" :class="{'seating-list__item--not-available' : roomLayout.island == null || isExceeded(roomLayout.island), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['island']}" >
                      <img src="../assets/img/seating-island.png" height="20" width="20" alt="Island Layout Icon">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('island')}">{{ roomLayoutOriginal.island != null ? roomLayoutOriginal.island : '-' }}</p>
                        <p v-if="isCapacityReduced('island')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.island != null ? roomLayout.island : '-' }}</p>
                      </div>
                  </li>
              </ul>

            <div class="dimensions-container" v-show="roomHasDimension">

                <h4 class="dimension-title">{{ strings.roomdimensions }}</h4>

                <ul class="dimension-list">
                <li v-show="roomArea > 0" v-tooltip.top-center="strings.area">
                    <font-awesome-icon class="dimension-list-icon" :icon="['fas', 'expand-alt']" height="20" width="20" />
                    <p>{{ roomArea > 0 ? roomArea + ' ' + strings.meterSquared : '- ' }}</p>
                </li>
                <li v-show="roomHeight > 0" v-tooltip.top-center="strings.height">
                    <font-awesome-icon class="dimension-list-icon" :icon="['fas', 'level-up-alt']" height="20" width="20" />
                    <p>{{ roomHeight > 0 ? roomHeight + ' ' + strings.meter : '- ' }}</p>
                </li>
                <li v-show="roomWidth > 0" v-tooltip.top-center="strings.width">
                    <font-awesome-icon class="dimension-list-icon" :icon="['fas', 'arrows-alt-h']" height="20" width="20" />
                    <p>{{ roomWidth > 0 ? roomWidth + ' ' + strings.meter : '- ' }}</p>
                </li>
                <li v-show="roomLength > 0" v-tooltip.top-center="strings.length">
                    <font-awesome-icon class="dimension-list-icon" :icon="['fas', 'arrows-alt-v']" height="20" width="20" />
                    <p>{{ roomLength > 0 ? roomLength + ' ' + strings.meter : '- ' }}</p>
                </li>
                </ul>

            </div>
          </div>

        </div>

        <!-- Details -->

        <div class="radio__details js-radio-details" :class="{ 'radio__details--hidden' : isHidden}">
            <div v-if="!isHidden">
                <!-- Description -->
                <p class="small radio__single-detail roomDescription" v-html="roomDescriptionTranslated"></p>

                <tabs v-if="!isRegus" :options="{ useUrlFragment: false }">
                    <tab :name="strings.equipment" v-if="roomEquipment.length > 0">
                    <ul class="checklist">
                            <li v-show="!isOpera || roomEquipment.includes(item)" v-for="(item,key) in roomAllEquipment" class="checklist__item" :class="{'checklist__item--not-available': !roomEquipment.includes(item) }" :key="key">{{ item }}</li>
                        </ul>
                    </tab>
                    <tab :name="strings.equipmentwithfee" v-if="roomEquipmentFee.length > 0">
                        <ul class="checklist">
                            <li v-show="!isOpera || roomEquipmentFee.includes(item)" v-for="(item,key) in roomAllEquipment" class="checklist__item" :class="{'checklist__item--not-available': !roomEquipmentFee.includes(item) }" :key="key">{{ item }}</li>
                        </ul>
                    </tab>
                </tabs>
            </div>
        </div>
        <div class="package__list-container">
            <div v-if="showRatesFilterCheck('roomRental') && isShowRoomRentalWebBookable && isRoomDiscounted" class="divider"></div>
            <!-- Room Rental -->
            <div v-show="showRatesFilterCheck('roomRental') && isShowRoomRentalWebBookable && isRoomDiscounted" class="price__item-container" :class="{'price__item-disabled': (available == 0 || exceed == 'yes' || !valid_layout)}">
                <div class="price__item-description">
                    <div class="price__item-title">{{ strings.roomRental }} <span style="margin-bottom: 3px; padding: 5px 5px;" v-if="minimumSpend > 0" v-tooltip.top-center="`${strings.serviceWorth} ${currencySymbol} ${minimumSpend.toFixed(2)} ${strings.canBeAdded}`" class="ribbon ribbon--with-icon"
            > {{currencySymbol}} {{ strings.minimumSpendRequired }}</span></div>
                    <div v-if="!isRegus" class="price__item-delegate-size">{{strings.upto}} {{ roomMax }} {{ strings.people }}</div>
                    <div v-else class="price__item-delegate-size">{{strings.for}} {{ roomMax }} {{ strings.people }}</div>
                </div>
                <div class="price__item-price" :class="{'is_item_seasonal': hasReducedPrice && !notNumericMT}">
                    <!-- Room Rental pricing -->
                    <h3 class="radio__price original_price"
                        v-if="hasReducedPrice && !notNumericMT"
                        > {{ !isEnquiry && !notNumericMT ? currencySymbol : '' }} {{ $store.state.selectedLang === 'de' ?  correctOriginalPrice.toFixed(2).replace('.', ',') : correctOriginalPrice.toFixed()}}
                    </h3>
                    <h3 class="radio__price savings"
                    v-if="hasReducedPrice && !notNumericMT"
                    >{{displayDiscountAmount}}</h3>
                    <h3 class="radio__price"
                    :class="{ is_seasonal: hasReducedPrice }"
                    >{{ !isEnquiry && !notNumericMT ? currencySymbol : '' }} {{ enquiryPriceCheck(totalPriceInPriceDetails) }}
                    </h3>
                    <span class="radio__price include_vat_text" v-if="!isEnquiry && !notNumericMT">{{ strings.inclVAT }}</span>

                    <!-- Room Rental Price Details -->
                    <div v-if="!isEnquiry && !(available == 0 || exceed == 'yes' || !valid_layout)" class="price__item-price-help-text" v-on:click="togglePriceDetails(0)">
                        {{ strings.priceDetails }}<font-awesome-icon class="collapse-trigger-icon" :icon="['fas', isPriceDetailsOpened(0) ? 'chevron-up' : 'chevron-down']" />
                        <div v-if="isPriceDetailsOpened(0)" class="price__item-price-detail-container">
                            <div class="price__item-price-detail-title">{{ strings.priceDetails }}</div>

                            <div v-if="isDavinci" >
                                <div class="price__item-price-detail-item">
                                    <div class="price__item-price-detail-item-name">{{ strings.approxTotal }}</div>
                                    <div class="price__item-price-detail-item-price">${{localCurrencyCode}} {{ davinciLocalTotalPrice }}</div>
                                </div>
                            </div>
                            <!-- Prices -->
                            <div v-else>
                                <div class="price__item-price-detail-item">
                                    <div class="price__item-price-detail-item-name">{{ strings.roomRental }}</div>
                                    <div class="price__item-price-detail-item-price">
                                        <div>{{currencySymbol}} {{ getDEPrice(roomRentalPriceExclVAT.toFixed(2)) }}</div>

                                    </div>
                                </div>
                                <div class="price__item-price-detail-item">
                                    <div class="price__item-price-detail-item-name">{{ strings.vat }}</div>
                                    <div class="price__item-price-detail-item-price">{{currencySymbol}} {{ getDEPrice((roomRentalPrice - roomRentalPriceExclVAT).toFixed(2)) }}</div>
                                </div>
                                <div v-if="minimumSpend > 0" class="price__item-price-detail-item">
                                    <div class="price__item-price-detail-item-name">{{ strings.remainingMinSpend }} {{strings.inclVat}}</div>
                                    <div class="price__item-price-detail-item-price">{{currencySymbol}} {{ getDEPrice((minimumSpend).toFixed(2)) }}</div>
                                </div>
                                <!-- Total Price -->
                                <div class="divider"></div>
                                <div class="price__item-price-detail-item-total">
                                    <div class="price__item-price-detail-item-name">{{ strings.total }}</div>
                                    <div class="price__item-price-detail-item-price">
                                    <div>{{currencySymbol}} {{ totalPriceInPriceDetails }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button
                    v-if="isBE && (available == 1 && exceed == 'no' && valid_layout)"
                    href="" :data-id="id"
                    class="price__item-cta button button--success tabs__button book-now"
                    @click.stop.prevent="create($event)"
                    :class="{'button--disabled': isOutsideBusinessHours || isClosed || isLoading}"
                    :disabled="isOutsideBusinessHours || isClosed || isLoading || fkDelegatesErrorShouldShow"
                    >
                    {{ isInstantBooking && !isEnquiry ? strings.book :strings.sendRequest}}
                </button>
                <div v-if="available == 0 || exceed == 'yes' || !valid_layout">
                    <ul class="price_item-unavailable-message checklist" v-if="!isSmartSpace">
                        <li class="checklist__item-disabled--attention" v-if="exceed == 'yes'">
                            <img class="attentionImage" src="https://s3.eu-central-1.amazonaws.com/meetingpackage.com/assets/images/attention-icon.svg" alt="Attention Icon"/>
                            {{ strings.yourattendees}} ({{ this.$store.state.delegates }}) {{ strings.exceedthelimit }} {{ strings.thisroom }} ({{ roomMin}} - {{roomMax}})
                        </li>
                        <li class="checklist__item checklist__item--stack checklist__item--attention" v-if="available == 0 && exceed == 'no'" alt="Attention Icon">
                            <img class="attentionImage" src="https://s3.eu-central-1.amazonaws.com/meetingpackage.com/assets/images/attention-icon.svg"/>
                            {{ strings.roomnotavailable }}
                        </li>
                        <li class="checklist__item checklist__item--stack checklist__item--attention" v-if="!valid_layout && exceed == 'no' && available == 0" alt="Attention Icon">
                            <img class="attentionImage" src="https://s3.eu-central-1.amazonaws.com/meetingpackage.com/assets/images/attention-icon.svg"/>
                            {{ strings.thisRoomDoesNotHave }}
                        </li>
                    </ul>
                </div>
            </div>
            <!-- Packages List -->
            <div v-if="roomPackages.length > 0 && showRatesFilterCheck('packages')" class="divider"></div>
            <div v-if="showRatesFilterCheck('packages')">
                <div v-for="(packageItem, index) in roomPackages" :key="index">     
                    <div class="price__item-container" :class="{'price__item-disabled': packageItem.allRoomUnavailable == 'yes' || packageItem.exceed == 'yes' || packageItem.available == 0 || available == 0 || exceed == 'yes' || !valid_layout}">
                        <div class="price__item-description">
                            <div class="price__item-title">{{packageItem.title[selectedLang] ? packageItem.title[selectedLang] : packageItem.title.en}}</div>
                            <div class="price__item-delegate-size">{{getPackageMinimumDelegate(packageItem.package_min)}} - {{packageItem.package_max}} {{ strings.people }}</div>

                            <div v-if="packageItem.is_new || isOpera" class="price__item-details-content-list">
                                <div class="price__item-details-content-item checklist" v-for="(content, contentIndex) in packageItem.content" :key="contentIndex">
                                    <div class="price__item-details-content checklist__item">{{content.name}}</div>
                                        <ul v-if="content.event_items" class="event_item_list">
                                            <li v-for="(event_item) in content.event_items" :key="event_item.id" >
                                                {{event_item.name}}
                                            </li>
                                        </ul>            
                                </div>
                            </div>

                            <div v-else class="price__item-details-content-list">
                                <div class="price__item-details-content-item checklist" v-for="(service, serviceIndex) in packageItem.services" :key="serviceIndex">
                                    <div class="price__item-details-content checklist__item">{{service}}</div>
                                </div>
                            </div>

                            <div v-if="packageItem.description != '' && packageItem.description != null" class="price__item-subtitle" v-on:click="togglePackageDetails(packageItem.id)">
                                {{ strings.packageDetails }}<font-awesome-icon class="collapse-trigger-icon" :icon="['fas', isPackageDetailsOpened(packageItem.id) ? 'chevron-up' : 'chevron-down']" />
                            </div>
                            <div class="price__item-details" v-if="isPackageDetailsOpened(packageItem.id)">
                                <div class="price__item-details-description" v-html="getTranslations(packageItem.description)"></div>
                            </div>
                        </div>

                        <div class="price__item-price package__items" :class="{'is_item_seasonal': packageHasReducedPrice(packageItem.correct_price) && !isPackageEnquiry(packageItem.correct_price)}">
                            <!-- Package Price -->
                            <h3 class="radio__price savings" v-if="packageHasReducedPrice(packageItem.correct_price) && !isPackageEnquiry(packageItem.correct_price)" >{{displayPackageDiscountAmount(packageItem)}}</h3>

                            <p class="aside__total_be">
                                <span class="radio__price original_price" v-if="packageHasReducedPrice(packageItem.correct_price) && !isPackageEnquiry(packageItem.correct_price)">{{ currencySymbol }} {{ packageEnquiryPriceCheck(getDEPrice(parseFloat(packageTotalOriginalPrice(packageItem) / 100).toFixed(2)), packageItem.correct_price) }}</span>
                                <span class="radio__price" :class="{'is_package_total_price': packageHasReducedPrice(packageItem.correct_price)}">{{ !isPackageEnquiry(packageItem.correct_price) ? currencySymbol : '' }} {{ packageEnquiryPriceCheck(getDEPrice(parseFloat(packageTotalPrice(packageItem, false) / 100).toFixed(2)), packageItem.correct_price) }} </span>
                                <span class="radio__price include_vat_text">{{ !isPackageEnquiry(packageItem.correct_price) ? strings.inclVAT : '' }}</span>
                            </p>

                            <div v-if="!isPackageEnquiry(packageItem.correct_price) && !(packageItem.allRoomUnavailable == 'yes' || packageItem.exceed == 'yes' || packageItem.available == 0)" class="price__item-price-help-text" v-on:click="togglePriceDetails(packageItem.id)">
                                {{ strings.priceDetails }}<font-awesome-icon class="collapse-trigger-icon" :icon="['fas', isPriceDetailsOpened(packageItem.id) ? 'chevron-up' : 'chevron-down']" />
                                <div v-if="isPriceDetailsOpened(packageItem.id)" class="price__item-price-detail-container">
                                    <div class="price__item-price-detail-title">
                                        <div class="price__item-price-detail-item">
                                            <div class="price__item-price-detail-item-name"> 
                                            {{ strings.priceDetails }} 
                                            </div>
                                            <div class="price__item-price-detail-item-price"> 
                                            {{ currencySymbol }} {{ getDEPrice(
                                                parseFloat(
                                                (packageTotalPrice(packageItem, false) / 100) / 
                                                getPackageCalculatedPriceDelegate(
                                                    packageItem.package_min
                                                )
                                                ).toFixed(2)
                                            ) }}/{{ strings.person }}  
                                            </div>
                                        </div>
                                    </div>

                                    <div class="price__item-price-detail-item">
                                        <div class="price__item-price-detail-item-name">
                                            {{ strings.withoutVat }}
                                        </div>
                                        <div class="price__item-price-detail-item-price">{{ currencySymbol }} {{ getDEPrice(parseFloat(packageTotalPrice(packageItem, true) / 100).toFixed(2)) }}</div>
                                    </div>
                                    <div class="price__item-price-detail-item">
                                        <div class="price__item-price-detail-item-name">{{ strings.vat }}</div>
                                        <div class="price__item-price-detail-item-price">{{ currencySymbol }} {{ getPackageTaxTotal(packageItem) }}</div>
                                    </div>
                                    <div class="divider"></div>
                                    <div class="price__item-price-detail-item-total">
                                      <div class="price__item-price-detail-item-name">{{ strings.total }}</div>
                                      <div class="price__item-price-detail-item-price">
                                        <div>{{ currencySymbol }} {{ getDEPrice(parseFloat(packageTotalPrice(packageItem, false) / 100).toFixed(2)) }}</div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button
                          v-if="!(packageItem.allRoomUnavailable == 'yes' || packageItem.exceed == 'yes' || packageItem.available == 0)"
                          class="price__item-cta button button--success book-now"
                          :data-id="id"
                          :class="{'button--disabled': isOutsideBusinessHours || isClosed || isLoading}" 
                          :disabled="isOutsideBusinessHours || isClosed || isLoading || fkDelegatesErrorShouldShow"
                          @click.stop.prevent="createPackageBooking($event, packageItem.id)"
                        >{{ isInstantBooking && !isPackageEnquiry(packageItem.correct_price) ? strings.book :strings.sendRequest}}</button>
                        <ul v-else class="price_item-unavailable-message checklist">
                            <li class="checklist__item-disabled--attention" v-if="packageItem.exceed == 'yes'">
                              <img class="attentionImage" src="https://s3.eu-central-1.amazonaws.com/meetingpackage.com/assets/images/attention-icon.svg" alt="Attention Icon"/>
                              {{ strings.yourattendees }} ({{ s_delegates }}) {{ strings.exceedthelimit }} {{ strings.thispackage }} ({{packageItem.package_max}})
                            </li>
                            <li class="checklist__item-disabled--attention" v-if="packageItem.available == 0 && packageItem.exceed == 'no'">
                              <img class="attentionImage" src="https://s3.eu-central-1.amazonaws.com/meetingpackage.com/assets/images/attention-icon.svg" alt="Attention Icon"/>
                              {{ strings.noneofroomavailableinpackage }}
                            </li>
                            <li class="checklist__item-disabled--attention" v-if="packageItem.allRoomUnavailable == 'yes' && packageItem.exceed == 'no' && packageItem.available != 0">
                              <img class="attentionImage" src="https://s3.eu-central-1.amazonaws.com/meetingpackage.com/assets/images/attention-icon.svg" alt="Attention Icon"/>
                              {{ strings.noneofroomfitsattendees }}
                            </li>
                        </ul>
                    </div>
                    <div v-if="index === (roomPackages.length - 1) && roomPackageCount > 2" class="showmore-divider">
                        <div class="showmore-text" v-on:click="isShowAllPackages = !isShowAllPackages">
                            {{isShowAllPackages ? strings.showLessRates : strings.showMoreRates}}
                            <font-awesome-icon class="package-rates-collapse-icon" :icon="['fas', isShowAllPackages ? 'chevron-up' : 'chevron-down']" />
                        </div>
                    </div>
                    <div v-else-if="roomPackages && index !== (roomPackages.length - 1)" class="divider"></div>
                </div>
            </div>

        </div>

        <!-- Call-to-action -->
        <div v-if="!isBE">
            <div class="button radio__cta radio__cta--selected" v-if="isRoomSelected(id)">{{ strings.selected }}</div>
            <div class="button radio__cta" v-else>{{ strings.select }}</div>
        </div>

    </label>
    <lightbox
         :images="images"
         ref="roomLightbox"
         :showLightBox="false"
         :show-caption="false"
     ></lightbox>
    </div>
</template>

<script>
import Vue from 'vue'
import Lightbox from 'vue-image-lightbox';
import moment from 'moment';
import VueResource from 'vue-resource';
import VTooltip from 'v-tooltip'
import $ from 'jquery'

import * as hf from '../assets/misc/helperFunctions.js'
import ModalComponent from './ModalComponent';
import * as dataLayer from '../assets/misc/dataLayer.js';

Vue.use(VTooltip);
Vue.use(VueResource);

export default {
    data() {
        return {
            show360Modal: false,
            isHidden : true,
            images: [],
            roomDescriptionTranslated: this.roomDescription,
            isEnquiry: false,
            packageDetailsOpened: [],
            priceDetailsOpened: [],
            isShowAllPackages: false,
            roomPackageCount: 0,
        }
    },
    components: {
      Lightbox,
      ModalComponent
    },
    props: [
        'id',
        'title',
        'instantBookable',
        'roomMin',
        'roomMax',
        'roomPriceVat',
        'correctPrice',
        'roomHalfDay',
        'roomFullDay',
        'roomDescription',
        'roomLayout',
        'roomLayoutOriginal',
        'roomHeight',
        'roomWidth',
        'roomLength',
        'roomArea',
        'roomEquipment',
        'roomEquipmentFee',
        'packages',
        'priceType',
        'chosenPriceType',
        'available',
        'exceed',
        'valid_layout',
        'no_layout',
        'image',
        'selected_room',
        'day',
        'isSmartSpace',
        'demand',
        'minRevenue',
        'currentPackage',
        'threeSixtyView',
        'mt_length',
        'position',
        'isWebBookable',
        ],
    methods: {
        enquiryPriceCheck(price) {
            if (Number(price.replace(',', '.')) > 0) { 
                return price         
            } else {
                // Check original price
                if (Number(this.correctOriginalPrice) > 0 && this.correctPrice.price_category === 'disc_price')
                    return price
            }
            return this.$store.state.strings.enquiry;
        },
        packageEnquiryPriceCheck(price, packageCorrectPrice) {
            if (Number(price.replace(',', '.')) > 0) { 
                return price         
            } else {
                // Check original price
                if (Number(packageCorrectPrice.original_price) > 0 && packageCorrectPrice.price_category === 'disc_price')
                    return price
            }
            return this.$store.state.strings.enquiry;
        },
        getPackageTaxTotal(packageItem) {
            if (packageItem.correct_price.backend_price == true) {
                return (packageItem.correct_price.tax_total/100).toFixed(2)
            }
            // frontend price logic
            return this.getDEPrice( (parseFloat(this.packageTotalPrice(packageItem, false) / 100) - parseFloat(this.packageTotalPrice(packageItem, true) / 100)).toFixed(2))
        },
        getPackageUnitPrice(packageItem) {
            if (packageItem.correct_price.backend_price == true) {
                return (packageItem.correct_price.unit_price_no_vat/100).toFixed(2)
            }
            // frontend price logic
            return this.getDEPrice(parseFloat((packageItem.correct_price.price_excl_vat !== 0 ? packageItem.correct_price.price_excl_vat : packageItem.correct_price.price) / 100).toFixed(2))
        },
        layoutEnabled(layoutName){
            let self = this;
            if(this.isOpera){
                if(this.currentTab == 'room'){
                    let found = this.$store.state.seatingOrderList.find(obj => obj.text.toLowerCase() == layoutName);
                    return typeof(found) !== "undefined"  && found !== null;
                } else {
                    if(this.isMoreThanOneDay){
                        this.eventList.forEach(event_el => {
                            if(parseInt(self.day) == parseInt(event_el.day)){
                                event_el.packages.forEach(package_el => {
                                    if(parseInt(package_el.id) == event_el.selected_package){
                                        let operaSelectedLayoutCode = hf.getLayoutCode(package_el.selected_layout);
                                        return operaSelectedLayoutCode == layoutName;
                                    }
                                });
                            }
                        });
                    } else {
                        let packageList = this.$store.state.packageInfo;
                        let selectedPackage = this.$store.state.selected_package;
                        packageList.forEach(package_el => {
                            if(parseInt(package_el.id) == parseInt(selectedPackage)){
                                let operaSelectedLayoutCode = hf.getLayoutCode(package_el.selected_layout);
                                return operaSelectedLayoutCode == layoutName;
                            }
                        });
                    }
                }
            }
            return this.roomLayout[layoutName] != null  && this.roomLayout[layoutName] > 0;
        },
        translateDurationType(length){
            let duration_type = "other";
            if(length <= 5){
            duration_type = "half-day";
            }else if(length <= 12){
                duration_type = "full-day";
            }
            return duration_type;
        },
        storeProduct(product, venue){
            let isRoomType = product.order_type == 'room';
            product.layout_en = this.$store.state.strings.layouts_en[product.layout];
            if(isRoomType){
                switch(product.chosen_price){
                    case 'halfday':
                        product.total_price = this.roomHalfDay;
                        break;
                    case 'fullday':
                        product.total_price = this.roomHalfDay;
                        break;
                    default:
                        product.total_price = this.roomPriceVat;
                        break;
                }
            }else{
                product.total_price = product.correct_price.price;
            }

            let payload = {
                "id": product.id,
                "name": product.title,
                "category": product.category,
                "brand": this.$store.state.venueInfo.title + ' - ' + this.$store.state.venueInfo.id,
                "price":  product.total_price,
                "quantity": isRoomType ? 1: product.delegates,
                "dimension3": this.$store.state.venueInfo.city,
                "dimension4": this.$store.state.venueInfo.country_code,
                "dimension5": this.$store.state.venueInfo.venue_type_en,
                "dimension6": product.mt_length,
                "dimension7": this.translateDurationType(product.mt_length),
                "dimension8": product.layout_en,
                "dimension9": moment(product.start,'DD-MM-YYYY HH:mm').format("DD/MM/YYYY HH:mm"),
                "dimension10": moment(product.end,'DD-MM-YYYY HH:mm').format("DD/MM/YYYY HH:mm"),
                "dimension12": product.isInstantBookable == 1 ? 'instant booking': product.total_price ? 'booking request': "enquiry",
                "metric1": product.delegates,
                "metric2": isRoomType ? product.total_price: product.total_price / product.delegates,
            };

            const checkoutDelegates = {
                package_min: product.correctDelegates ?? 0,
                delegates: product.delegates ?? 0,
                order_type: product.order_type
            };
            localStorage.setItem("checkoutDelegates", JSON.stringify(checkoutDelegates));

            localStorage.setItem('checkoutProduct', JSON.stringify(payload));
            localStorage.setItem('venueInfo', JSON.stringify(venue));
        },
        pushSelectItem(product){
            let isRoomType = product.order_type == 'room';
            product.layout_en = this.$store.state.strings.layouts_en[product.layout];
            let instantBooking = this.isInstantBooking;
            product.total_price = product.correct_price.price;
            let meetingStartTime = moment(this.$store.state.datetime, 'DD-MM-YYYY HH:mm');
            let meetingEndTime = moment(this.$store.state.endDatetime, 'DD-MM-YYYY HH:mm');
            let layout = this.$store.state.selectedLayout;
            if(product.category == "room"){
                product.category = "meetingroom";
            }
            let payload = [{
                    "item_id": product.id,
                    "item_name": product._title,
                    "item_category": product.category,
                    "item_brand": this.$store.state.venueInfo.title + ' - ' + this.$store.state.venueInfo.id,
                    "item_price":  product.total_price,
                    "quantity": isRoomType ? 1: product.delegates,
                    "item_city": this.$store.state.venueInfo.city,
                    "item_country": this.$store.state.venueInfo.country_code,
                    "item_category2": this.$store.state.venueInfo.venue_type_en,
                    "item_variant": this.translateDurationType(product.mt_length),
                    "item_category3": layout == '_none' ? 'anything_goes': layout, //Meeting room seating layout
                    "item_start_date": meetingStartTime.format('DD/MM/YYYY HH:mm'), //Event start time 
                    "item_end_date-": meetingEndTime.format('DD/MM/YYYY HH:mm'), //Event end time
                    "item_category4": instantBooking? 'instant': product.total_price ? 'priced': "enquiry",
                    "price": isRoomType ? product.total_price: product.total_price / product.delegates,
                    "item_delegates": product.delegates,
                    "item_list_name": 'Search'
                    }];
            localStorage.setItem('checkoutItemProduct', JSON.stringify(payload));
            dataLayer.pushSelectItem(payload);
        },
        openRoomLightBox(index) {
            let allImages;
            this.images = [];
            for (let i=0; i <  this.image.length; i++) {
              allImages = {
                thumb: this.image[i],
                src: this.image[i],
              }
              this.images.push(allImages);
            }

            if(this.image != '') {
                this.$refs.roomLightbox.showImage(index);
            }
        },
        isRoomSelected(roomID){

            let isBE = this.$store.state.isBE;
            if(isBE){
                return false;
            }
            if(this.$store.state.currentTab == 'room'){
                if(this.$store.state.selectedRoom == roomID){
                   this.$store.commit('detailsText', this.isHidden);
                    return true;
                }
            } else {
                if(this.$store.state.selectedRoominPackage == roomID){
                  this.$store.commit('detailsText', this.isHidden);
                  return true;
                }
            }

        },
        setSelectedRoom(roomID, position){
            this.$store.commit('setSelectedPosition', position);
            this.$store.commit('detailsText', this.isHidden);
            if(this.isBE){
                return;
            }

            if(this.$store.state.currentTab == 'room'){
                this.$store.commit('setSelectedRoom', roomID);
                this.$store.commit('setLayoutsInRoom', roomID)
                this.$store.commit('changeSelectedPrice', roomID);
            } else {
                this.$store.commit('setSelectedRoominPackage', roomID);
                this.$store.commit('setLayoutsInRoom', roomID);

            }
        },
        toggleDetails(){
           this.$store.commit('toggleDetailId', '');
           this.isHidden = !this.isHidden;
        },
        chooseLayout(value, status){
            if(this.isBE){
                //return;
            }

            let delegates = '';
            if(this.isMoreThanOneDay){
                let _day = this.day;
                this.eventList.forEach(event_el => {
                    if(parseInt(_day) == parseInt(event_el.day)){
                        delegates = event_el.delegates;
                    }
                });
            } else {
                delegates = this.$store.state.delegates;
            }

            if(status !== null && parseInt(status) >= delegates) {
                this.$store.commit('setSelectedLayout', value);
                this.$store.commit('setSelectedLayoutinPackage', value);
            }
        },
        isExceeded(value){
            let delegates = '';
            if(this.isMoreThanOneDay){
                let _day = this.day;
                this.eventList.forEach(event_el => {
                    if(parseInt(_day) == parseInt(event_el.day)){
                        delegates = event_el.delegates;
                    }
                });
            } else {
                delegates = this.$store.state.delegates;
            }
            if(parseInt(value) >= parseInt(delegates)){
                return false;
            } else {
                return true;
            }
        },
        create(event, isPackageBooking = false){
            // Regus Booking
            if (this.isRegus) {
                this.$store.state.roomInfo.forEach(el => {
                    if(el.id == event.target.attributes['data-id'].value){
                        this.$store.dispatch('changeRoomRegus', el)
                        let totalPrice = this.$store.state.price;

                        this.$store.commit('setRoomTotalPrice', parseFloat(totalPrice).toFixed(2));

                        let delegates = parseInt(this.$store.state.delegates);
                        let price = parseFloat(totalPrice / delegates).toFixed(2);
                        this.$store.commit('setRoomPrice', price);

                        this.createRegusBooking()
                    }
                })
            } else {
                // Non-regus Booking
                const oldCheckOutHosts = [];
                if (
                    oldCheckOutHosts.some(host => host === window.location.host)
                ) {
                    this.createBooking(event, isPackageBooking)
                } else {
                    this.createNewBooking(event, isPackageBooking)
                }
            }
        },
        async createBooking(event, isPackageBooking) {
            let roomID = event.target.attributes['data-id'].value;
            let _day = this.day;
            let self = this;
            let currentTab = this.currentTab;
            let lang = this.$store.state.selectedLang;
            let selectedProduct;
            if(lang == 'en'){
                lang = '';
            } else {
                lang = '/' + lang;
            }
            if(!isPackageBooking){
                let roomList = this.$store.state.roomInfo;
                roomList.forEach(element => {
                if(element.id == roomID){
                        selectedProduct = Object.assign({}, element);
                        selectedProduct.title = "room - " + element.title;
                        selectedProduct._title = element.title;
                        selectedProduct.id = "r" + roomID;
                        selectedProduct.category = 'room';
                }
                });
            }else{
                let packageList = this.$store.state.packageInfo;
                packageList.forEach(element => {
                if(element.id == this.$store.state.selectedPackage){
                        selectedProduct = Object.assign({}, element);
                        selectedProduct.title = "package - " + element.title;
                        selectedProduct._title = element.title;
                        selectedProduct.id = "n" + this.$store.state.selectedPackage;
                        selectedProduct.category = 'package';
                }
                });
            }


            let chosenItemText = {};
            if(this.isMoreThanOneDay){
                let _event = {};
                this.eventList.forEach(event_el => {
                    if(parseInt(_day) == parseInt(event_el.day)){
                        let start_date = moment(event_el.date, 'DD-MM-YYYY').format("LL");
                        event_el.selected_room = roomID;
                        chosenItemText.event_date = 'Event date: ' + start_date + ' ' + event_el.start_time + ' to ' + event_el.end_time;
                        chosenItemText.delegates = 'Delegates: ' + event_el.delegates;
                        if(!isPackageBooking){
                            // Loop through all the rooms to get the name of selected package.
                            event_el.finalList.forEach(room_el => {
                                if(parseInt(room_el.id) == parseInt(event_el.selected_room)){
                                    event_el.selected_room_name = room_el.title;
                                    let selectedPrice = 0;
                                    if(self.chosenPriceType == 'halfday'){
                                        selectedPrice = room_el.calculated_prices.halfday_price;
                                    } else if(self.chosenPriceType == 'fullday') {
                                        selectedPrice = room_el.calculated_prices.fullday_price;
                                    } else if(self.chosenPriceType == 'opera') {
                                        selectedPrice = room_el.calculated_prices.price_vat * parseInt(self.meetingLength);
                                    } else {
                                        selectedPrice = room_el.calculated_prices.price_vat * parseInt(self.meetingLength);
                                    }
                                    event_el.selected_room_price = selectedPrice;
                                }
                            });
                            chosenItemText.room = 'Room: ' + event_el.selected_room_name;
                            chosenItemText.layout = 'Seating order: ' + hf.getLayoutName(self.$store.state.selectedLayout);
                            chosenItemText.price = 'Price: ' + self.currencySymbol + ' ' + parseFloat(event_el.selected_room_price) / 100;
                        } else {
                            // Loop through all the packages to get the name of selected package.
                            event_el.packages.forEach(package_el => {
                                if(parseInt(package_el.id) == event_el.selected_package){
                                    event_el.selected_package_name = package_el.title;
                                    event_el.selecled_package_price = package_el.calculated_prices.price_vat;
                                    event_el.package_min = package_el.package_min;
                                }
                            });
                            // Get the name of selected room
                            event_el.room_list_in_package.forEach(room_el => {
                                if(parseInt(room_el.id) == parseInt(event_el.selected_room)){
                                    event_el.selected_room_name = room_el.title;
                                }
                            });
                            chosenItemText.package = 'Package: ' + event_el.selected_package_name;
                            chosenItemText.room = 'Room: ' + event_el.selected_room_name;
                            chosenItemText.layout = 'Seating order: ' + hf.getLayoutName(self.$store.state.selectedLayoutinPackage);
                            let tempDelegates = parseInt(event_el.delegates) > parseInt(event_el.package_min) ? parseInt(event_el.delegates) : parseInt(event_el.package_min);
                            chosenItemText.price = 'Price: ' + self.currencySymbol + ' ' + (parseFloat(event_el.selecled_package_price) / 100) * tempDelegates;
                        }
                        event_el.chosenItemText = chosenItemText;

                        event_el.isChosen = 1;
                        _event = event_el;
                    }
                });

                this.$store.commit('setEventList', this.eventList);
                this.$store.commit('pushToFinalEvents', _event);
                this.$store.commit('setTabIndex', parseInt(_day));
            }else {
                let isOpera = this.$store.state.isOpera;
                let startD = this.$store.state.datetime;
                let operaStartD = moment(startD, 'DD-MM-YYYY HH:mm');
                operaStartD = operaStartD.format('YYYY-MM-DDTHH:mm:ss');
                let endD = moment(startD, 'DD-MM-YYYY HH:mm');
                let mt_length = '';
                let currentTab = this.$store.state.currentTab;
                let isEnquiry = this.$store.state.showEnquiryForm;
                let baseUrl = this.$store.state.baseUrl;

                if(this.$store.state.meeting_length == 'overnight'){
                    mt_length = 24;
                } else if(this.$store.state.meeting_length == 'twodays'){
                    mt_length = 36;
                } else {
                    mt_length = parseInt(this.$store.state.meeting_length);
                }

                endD = endD.add(mt_length, 'hours');
                let operaEndD = endD;
                endD = endD.format('DD-MM-YYYY HH:mm');
                operaEndD = operaEndD.format('YYYY-MM-DDTHH:mm:ss');

                this.$store.commit('setProcessing', 'yes');
                // Check if this is Opera Venue.
                if(isOpera){

                    let roomIF = [];
                    let packageIF = [];
                    let layout = '';
                    let opera_layout_code = '';
                    let layout_code = '';
                    if(!isPackageBooking){
                        let roomList = this.$store.state.roomInfo;
                        roomList.forEach(element => {
                            if(element.id == roomID){
                                let selectedPrice = 0;
                                let totalPrice = 0;
                                roomIF['name'] = element.title;
                                roomIF['photo'] = element.room_pictures[0];
                                roomIF['code'] = element.code;
                                roomIF['rate_code'] = element.rate_code;
                                if(self.chosenPriceType == 'halfday'){
                                    selectedPrice = element.calculated_prices.halfday_price;
                                    totalPrice = selectedPrice;
                                } else if(self.chosenPriceType == 'fullday') {
                                    selectedPrice = element.calculated_prices.fullday_price;
                                    totalPrice = selectedPrice;
                                } else {
                                    selectedPrice = element.calculated_prices.price_vat;
                                    totalPrice = parseInt(selectedPrice) * mt_length
                                }
                                roomIF['roomPriceOption'] = {
                                    'unit_price' : selectedPrice,
                                    'price_type' : self.chosenPriceType,
                                    'is_opera_room' : element.code ? true : false,
                                    'total_price' : totalPrice
                                };
                            }
                        });
                        layout_code = this.$store.state.selectedLayout;
                        opera_layout_code = hf.MPLayoutToOperaLayout(layout_code, this.$store.state.venueInfo.operaServer),
                        layout = hf.getLayoutName(layout_code);
                        packageIF['name'] = '';
                        packageIF['code'] = '';
                        packageIF['package_rate_code'] = '';
                    } else {
                        let roomList = this.$store.state.rooms_in_package;
                        roomList.forEach(element => {
                        if(element.id == roomID){
                            roomIF['name'] = element.title;
                            roomIF['photo'] = element.room_pictures[0];
                            roomIF['code'] = element.code;
                            roomIF['rate_code'] = '';
                        }
                        layout_code = this.$store.state.selectedLayoutinPackage;
                        opera_layout_code = hf.MPLayoutToOperaLayout(layout_code, this.$store.state.venueInfo.operaServer),
                        layout = hf.getLayoutName(layout_code);
                        });

                        let packageList = this.$store.state.packageInfo;
                        packageList.forEach(element => {
                        if(element.id == this.$store.state.selectedPackage){
                            packageIF['name'] = element.title;
                            packageIF['code'] = element.id;
                            packageIF['package_rate_code'] = element.package_rate_code;
                        }
                        });
                    }

                    let type = !isPackageBooking ? 'room' : 'package';

                    this.$store.dispatch('goToOperaCheckout', {
                        'type' : type,
                        'startD' : startD,
                        'endD' : endD,
                        'operaStartD' : operaStartD,
                        'operaEndD' : operaEndD,
                        'room' : roomIF['name'],
                        'room_id' : roomID,
                        'room_code' : roomIF['code'],
                        'room_price_option' : roomIF['roomPriceOption'],
                        'layout_name' : layout,
                        'layout_code' : layout_code,
                        'opera_layout_code' : opera_layout_code,
                        'room_rate_code' : roomIF['rate_code'],
                        'package' : packageIF['name'],
                        'package_code' : packageIF['code'],
                        'package_rate_code' : packageIF['package_rate_code'],
                        'isInstantBookable': this.instantBookable
                    });

                    return;
                }

            let ajaxUrl = baseUrl + '/apiv2/create/cart';


            let sentData = {};
            sentData.accepted_gdpr = this._accepted_gdpr;
            sentData.start = startD;
            sentData.end = endD;
            sentData.delegates = this.$store.state.delegates;
            sentData.isInstantBookable = this.instantBookable;
            sentData.order_type = isPackageBooking ? 'package' : 'room';
            sentData.marketing_platform_ids = dataLayer.getMarketingPlatformIds();
            sentData.mp_ga_session_data = await dataLayer.getGASessionInfo(window.mp_measurement_id);
            sentData.wl_ga_session_data = await dataLayer.getGASessionInfo(window.wl_measurement_id);
            sentData.user_agent = window.navigator.userAgent;
            var bookingType = 'room';
            var bookingRoom = 'room';
            if(!isPackageBooking){
                bookingRoom = roomID;
                sentData.room = roomID;
                sentData.layout = this.$store.state.selectedLayout;
                sentData.package_id = 'none';
                sentData.currency = this.$store.state.venueInfo.currency_code;
                sentData.venue_id = this.$store.state.venueInfo.id;
                sentData.language = lang;

                // Room price
                this.$store.commit('setSelectedRoom', roomID);
                this.$store.commit('changeSelectedPrice', roomID);
                this.$cookie.set('room_booking_type', this.$store.state.roomBookingType);
                let flag = this.$store.state.totalPriceIndicator;
                let roomPrice = this.$store.state.price;
                let totalPrice = '';
                if(flag == 'usual'){
                    if(mt_length == 24 || mt_length == 36){
                        totalPrice = 0;
                    } else {
                        totalPrice = roomPrice;
                    }
                }
                sentData.room_price = roomPrice;
                sentData.room_price_total = totalPrice;
                let product = {...sentData, ...selectedProduct };
                product.mt_length = mt_length;
                this.storeProduct(product,  this.$store.state.venueInfo);
                if(this.useNewCheckoutPage){
                    if(this.chosenPriceType == 'normal'){
                        totalPrice = parseFloat(roomPrice *  parseInt(mt_length)).toFixed(2);
                    }else{
                        totalPrice = parseFloat(roomPrice).toFixed(2);
                    }
                    sentData.chosenPriceType = this.chosenPriceType;
                    sentData.room_price_total = totalPrice;
                    this.$store.dispatch('goToCheckout', sentData);
                    return;
                }
                Vue.http.post(ajaxUrl, sentData).then(response => {
                    let data = response.body;
                    let url = baseUrl + lang + '/checkout/' + data;

                    // If booking.com here we set some cookies for the thank you page.
                    let site_url = window.location.host;
                    if(site_url == 'booking.meetingpackage.com' || site_url == 'meetingpackage.com' ){
                        let check_in_date = moment(this.$store.state.date, 'DD-MM-YYYY').format('YYYY-MM-DD');
                        let check_out_date = moment(check_in_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
                        let latlon = this.$store.state.venueInfo.latlon.split(',');
                        let latitude = latlon[0];
                        let longitude = latlon[1];
                        this.$cookie.set('bk_check_in_date', check_in_date);
                        this.$cookie.set('bk_check_out_date', check_out_date);
                        this.$cookie.set('bk_latitude', latitude);
                        this.$cookie.set('bk_longitude', longitude);
                    }

                    // Go to checkout page.
                        if(window.location.host == 'sjp.cwteasymeetings.com' || window.location.host == 'lilly.cwteasymeetings.com'){
                            this.$store.dispatch('goToCheckout', sentData);
                        } else {
                            window.location.href = url;
                        }

                    }, response => {
                });
            } else {
                // Package booking.
                bookingType = 'package';
                bookingRoom = roomID;

                sentData.room = roomID;
                sentData.layout = this.$store.state.selectedLayoutinPackage;
                sentData.package_id = this.$store.state.selectedPackage;
                sentData.venue_id = this.$store.state.venueInfo.id;
                sentData.language = lang;
                let product = {...sentData, ...selectedProduct };
                product.mt_length = mt_length;
                this.storeProduct(product,  this.$store.state.venueInfo);
                if(this.useNewCheckoutPage){
                    this.$store.commit('showCheckOutPage', 'yes');
                    this.$store.dispatch('goToCheckout', sentData);
                    return;
                }
                    Vue.http.post(ajaxUrl, sentData).then(response => {
                        let data = response.body;
                        let url = '';

                        url = baseUrl + lang + '/checkout/' + data;

                        // If booking.com here we set some cookies for the thank you page.
                        let site_url = window.location.host;
                        if(site_url == 'booking.meetingpackage.com' || site_url == 'meetingpackage.com'){
                            let check_in_date = moment(this.$store.state.date, 'DD-MM-YYYY').format('YYYY-MM-DD');
                            let check_out_date = moment(check_in_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
                            let latlon = this.$store.state.venueInfo.latlon.split(',');
                            let latitude = latlon[0];
                            let longitude = latlon[1];
                            this.$cookie.set('bk_check_in_date', check_in_date);
                            this.$cookie.set('bk_check_out_date', check_out_date);
                            this.$cookie.set('bk_latitude', latitude);
                            this.$cookie.set('bk_longitude', longitude);
                        }

                        // Go to checkout page.
                        if(window.location.host == 'sjp.cwteasymeetings.com' || window.location.host == 'lilly.cwteasymeetings.com'){
                            this.$store.dispatch('goToCheckout', sentData);
                        } else {
                            window.location.href = url;
                        }

                        }, response => {
                    });
                }
            }
        },
        async createNewBooking(event, isPackageBooking) {
            let roomID = event.target.attributes['data-id'].value;
            let _day = this.day;
            let self = this;
            let currentTab = this.currentTab;
            let lang = this.$store.state.selectedLang;
            let selectedProduct;
            if(lang == 'en'){
                lang = '';
            } else {
                lang = '/' + lang;
            }
            // Impression
            if(!isPackageBooking){
                let roomList = this.$store.state.roomInfo;
                roomList.forEach(element => {
                    if(element.id == roomID){
                            selectedProduct = Object.assign({}, element);
                            selectedProduct.title = "room - " + element.title;
                            selectedProduct._title = element.title;
                            selectedProduct.id = "r" + roomID;
                            selectedProduct.category = 'room';
                    }
                });
            } else {
                let packageList = this.$store.state.packageInfo;
                packageList.forEach(element => {
                    if(element.id == this.$store.state.selectedPackage){
                            selectedProduct = Object.assign({}, element);
                            selectedProduct.title = "package - " + element.title;
                            selectedProduct.id = "n" + this.$store.state.selectedPackage;
                            selectedProduct.category = 'package';
                    }
                });
            }

            // End Impression
            let chosenItemText = {};
            if(this.isMoreThanOneDay){
                let _event = {};
                this.eventList.forEach(event_el => {
                    if(parseInt(_day) == parseInt(event_el.day)){
                        let start_date = moment(event_el.date, 'DD-MM-YYYY').format("LL");
                        event_el.selected_room = roomID;
                        chosenItemText.event_date = 'Event date: ' + start_date + ' ' + event_el.start_time + ' to ' + event_el.end_time;
                        chosenItemText.delegates = 'Delegates: ' + event_el.delegates;
                        if(!isPackageBooking){
                            // Loop through all the rooms to get the name of selected package.
                            event_el.finalList.forEach(room_el => {
                                if(parseInt(room_el.id) == parseInt(event_el.selected_room)){
                                    event_el.selected_room_name = room_el.title;
                                    let selectedPrice = 0;
                                    if(self.chosenPriceType == 'halfday'){
                                        selectedPrice = room_el.calculated_prices.halfday_price;
                                    } else if(self.chosenPriceType == 'fullday') {
                                        selectedPrice = room_el.calculated_prices.fullday_price;
                                    } else if(self.chosenPriceType == 'opera') {
                                        selectedPrice = room_el.calculated_prices.price_vat * parseInt(self.meetingLength);
                                    } else {
                                        selectedPrice = room_el.calculated_prices.price_vat * parseInt(self.meetingLength);
                                    }
                                    event_el.selected_room_price = selectedPrice;
                                }
                            });
                            chosenItemText.room = 'Room: ' + event_el.selected_room_name;
                            chosenItemText.layout = 'Seating order: ' + hf.getLayoutName(self.$store.state.selectedLayout);
                            chosenItemText.price = 'Price: ' + self.currencySymbol + ' ' + parseFloat(event_el.selected_room_price) / 100;
                        } else {
                            // Loop through all the packages to get the name of selected package.
                            event_el.packages.forEach(package_el => {
                                if(parseInt(package_el.id) == event_el.selected_package){
                                    event_el.selected_package_name = package_el.title;
                                    event_el.selecled_package_price = package_el.calculated_prices.price_vat;
                                    event_el.package_min = package_el.package_min;
                                }
                            });
                            // Get the name of selected room
                            event_el.room_list_in_package.forEach(room_el => {
                                if(parseInt(room_el.id) == parseInt(event_el.selected_room)){
                                    event_el.selected_room_name = room_el.title;
                                }
                            });
                            chosenItemText.package = 'Package: ' + event_el.selected_package_name;
                            chosenItemText.room = 'Room: ' + event_el.selected_room_name;
                            chosenItemText.layout = 'Seating order: ' + hf.getLayoutName(self.$store.state.selectedLayoutinPackage);
                            let tempDelegates = parseInt(event_el.delegates) > parseInt(event_el.package_min) ? parseInt(event_el.delegates) : parseInt(event_el.package_min);
                            chosenItemText.price = 'Price: ' + self.currencySymbol + ' ' + (parseFloat(event_el.selecled_package_price) / 100) * tempDelegates;
                        }
                        event_el.chosenItemText = chosenItemText;

                        event_el.isChosen = 1;
                        _event = event_el;
                    }
                });

                this.$store.commit('setEventList', this.eventList);
                this.$store.commit('pushToFinalEvents', _event);
                this.$store.commit('setTabIndex', parseInt(_day));
            }else {
                let isOpera = this.$store.state.isOpera;
                let startD = this.$store.state.datetime;
                let operaStartD = moment(startD, 'DD-MM-YYYY HH:mm');
                operaStartD = operaStartD.format('YYYY-MM-DDTHH:mm:ss');
                let endD = moment(startD, 'DD-MM-YYYY HH:mm');
                let mt_length = '';
                let currentTab = this.$store.state.currentTab;
                let isEnquiry = this.$store.state.showEnquiryForm;
                let baseUrl = this.$store.state.baseUrl;

                if(this.$store.state.meeting_length == 'overnight'){
                    mt_length = 24;
                } else if(this.$store.state.meeting_length == 'twodays'){
                    mt_length = 36;
                } else {
                    mt_length = parseInt(this.$store.state.meeting_length);
                }

                endD = endD.add(mt_length, 'hours');
                let operaEndD = endD;
                endD = endD.format('DD-MM-YYYY HH:mm');
                operaEndD = operaEndD.format('YYYY-MM-DDTHH:mm:ss');

                this.$store.commit('setProcessing', 'yes');

                let ajaxUrl = baseUrl + '/apiv2/create/cart2';

                let sentData = {};
                sentData.language = this.selectedLang;
                sentData.marketing_platform_ids = dataLayer.getMarketingPlatformIds();
                sentData.mp_ga_session_data = await dataLayer.getGASessionInfo(window.mp_measurement_id);
                sentData.wl_ga_session_data = await dataLayer.getGASessionInfo(window.wl_measurement_id);
                sentData.user_agent = window.navigator.userAgent;
                sentData.venue_id = this.$store.state.venueInfo.id;
                sentData.venue_name = this.$store.state.venueInfo.title;
                //sentData.venue_pictures = this.$store.state.venueInfo.venue_pictures;
                sentData.discount_code = this.$store.state.discount_code;
                sentData.venue_type_en = this.$store.state.venueInfo.venue_type_en;
                sentData.country_code = this.$store.state.venueInfo.country_code;
                sentData.city = this.$store.state.venueInfo.city;
                sentData.terms_of_use = this.$store.state.venueInfo.terms_of_use;
                sentData.delegates = this.$store.state.delegates;
                sentData.order_type = isPackageBooking ? 'package' : 'room';

                sentData.events = [
                    {
                        'start' : startD,
                        'end' : endD,
                        'currency' : this.$store.state.venueInfo.currency_code,
                        'room' : {}
                    }
                ];
                let availability_id = '';
                let pms_info = {}
                let pms_availability_error = false;
                let pms_error = false;
                if(!isPackageBooking){
                    let selectedRoomInfo = this.$store.state.roomInfo.find(
                        obj => obj.id == roomID
                    )
                    availability_id = selectedRoomInfo.availability_id;
                    pms_info = selectedRoomInfo.pms_query_ids ? selectedRoomInfo.pms_query_ids : ''
                    pms_availability_error = selectedRoomInfo.pms_availability_error;
                    pms_error = selectedRoomInfo.pmsfa;
                    if(selectedRoomInfo.adjusted_meeting_length){
                        mt_length = selectedRoomInfo.adjusted_meeting_length;
                        endD = moment(startD, 'DD-MM-YYYY HH:mm');
                        endD = endD.add(mt_length, 'hours');
                        endD = endD.format('DD-MM-YYYY HH:mm');
                        sentData.events[0]['end'] = endD;
                    }
                    // Room price
                    this.$store.commit('setSelectedRoom', roomID);
                    this.$store.commit('changeSelectedPrice', roomID);
                    this.$cookie.set('room_booking_type', this.$store.state.roomBookingType);
                    let flag = this.$store.state.totalPriceIndicator;
                    let roomPrice = this.$store.state.price;

                    let totalPrice = '';
                    if(flag == 'usual'){
                        if(mt_length == 24 || mt_length == 36){
                            totalPrice = 0;
                        } else {
                            totalPrice = roomPrice;
                        }
                    } else {
                        totalPrice = roomPrice;
                    }

                    sentData.events[0].room.id = roomID;
                    sentData.events[0].room.name = selectedRoomInfo.title;
                    sentData.events[0].room.layout_code = this.$store.state.selectedLayout;
                    sentData.events[0].package = {};
                    sentData.events[0].room.total_price = totalPrice * 100;
                    sentData.events[0].room.price_type = selectedRoomInfo.calculated_prices.type;

                    //New fields for 100% discount code
                    sentData.events[0].room.price_category = selectedRoomInfo.correct_price.price_category;
                    sentData.events[0].room.original_price = selectedRoomInfo.correct_price.original_price;

                    sentData.events[0].room.type = this.chosenPriceType == 'normal' ? 'hourly' : this.chosenPriceType;
                    sentData.events[0].room.isInstantBookable = this.isInstantBooking;

                    let product = {...sentData, ...selectedProduct };
                    product.mt_length = mt_length;
                    this.storeProduct(product,  this.$store.state.venueInfo);

                    if(this.useNewCheckoutPage){
                        if(this.chosenPriceType == 'normal'){
                            totalPrice = parseFloat(roomPrice *  parseInt(mt_length)).toFixed(2);
                        }else{
                            totalPrice = parseFloat(roomPrice).toFixed(2);
                        }
                        sentData.chosenPriceType = this.chosenPriceType;
                        sentData.room_price_total = totalPrice;
                        this.$store.dispatch('goToCheckout', sentData);
                        return;
                    }

                } else {
                    // Package booking.
                    let packageInfo = JSON.parse(JSON.stringify(this.$store.state.packageInfo))
                    let selectedPackageInfo = packageInfo.find(
                        obj => obj.id == this.$store.state.selectedPackage
                    )
                    let selectedRoominPackageInfo = this.$store.state.rooms_in_package.find(
                        function (obj) {
                            return obj.id == roomID;
                        }
                    )
                    let selectedRoomInfo = this.$store.state.roomInfo.find(
                        obj => obj.id == roomID
                    )
                    availability_id = selectedPackageInfo.availability_id;
                    if(selectedRoomInfo.availability_id){
                        availability_id = selectedRoomInfo.availability_id;
                    }
                    pms_info = selectedPackageInfo.pms_query_ids ? selectedPackageInfo.pms_query_ids : ''
                    if(selectedRoomInfo.pms_room_id){
                        pms_info.pms_room_id = selectedRoomInfo.pms_room_id;
                    }
                    pms_availability_error = selectedRoomInfo.pms_availability_error;
                    pms_error = selectedRoomInfo.pmsfa;
                    if(selectedRoominPackageInfo.adjusted_meeting_length){
                        mt_length = selectedRoominPackageInfo.adjusted_meeting_length;
                        endD = moment(startD, 'DD-MM-YYYY HH:mm');
                        endD = endD.add(mt_length, 'hours');
                        endD = endD.format('DD-MM-YYYY HH:mm');
                        sentData.events[0]['end'] = endD;
                    }

                    // Get the correct_price for package based on the selected room.
                    let roomCheck = selectedPackageInfo.rooms.find(room => {
                        return room.id == roomID
                    })
                    if (roomCheck.package_correct_price) {
                        selectedPackageInfo.correct_price = roomCheck.package_correct_price
                    }

                    let correctPackageMinDelegate =
                        parseInt(selectedRoominPackageInfo.min) < parseInt(selectedPackageInfo.package_min)
                        ? parseInt(selectedPackageInfo.package_min)
                        : parseInt(selectedRoominPackageInfo.min)

                    let correctDelegates =
                        parseInt(this.$store.state.delegates) < correctPackageMinDelegate
                        ? correctPackageMinDelegate
                        : parseInt(this.$store.state.delegates)

                    let packagePrice = this.$store.state.price;

                    sentData.events[0].room.id = roomID;
                    sentData.events[0].room.name = selectedRoominPackageInfo.title;
                    sentData.events[0].room.layout_code = this.$store.state.selectedLayoutinPackage;
                    sentData.events[0].room.isInstantBookable = this.isInstantBooking;

                    sentData.events[0].room.price_category = selectedRoomInfo.correct_price.price_category;
                    sentData.events[0].room.original_price = selectedRoomInfo.correct_price.original_price;

                    sentData.events[0].package = {
                        'id' : this.$store.state.selectedPackage,
                        'name' : selectedPackageInfo.title,
                        'rate_code' : selectedPackageInfo.package_rate_code,
                        'package_min': parseInt(selectedPackageInfo.package_min),
                        'price_type': selectedPackageInfo.correct_price.price_category,
                        'includes': selectedPackageInfo.content,
                        'source_id': selectedPackageInfo.source_id
                    };

                    if (selectedPackageInfo.correct_price.backend_price == true) {
                        sentData.events[0].package = {
                            ...sentData.events[0].package,
                            total_price: selectedPackageInfo.correct_price.total_price,
                            unit_price: selectedPackageInfo.correct_price.unit_price
                        }
                    } else {
                        sentData.events[0].package = {
                            ...sentData.events[0].package,
                            total_price: selectedPackageInfo.correct_price.price * correctDelegates,
                            unit_price: selectedPackageInfo.correct_price.price,
                            total_price_excl_vat: Number(parseFloat(selectedPackageInfo.correct_price.price_excl_vat * correctDelegates).toFixed(2)),
                        }
                    }

                    let product = {...sentData, ...selectedProduct };
                    product.mt_length = mt_length;
                    product.correctDelegates = correctDelegates;

                    this.storeProduct(product,  this.$store.state.venueInfo);
                    if(this.useNewCheckoutPage){
                        this.$store.commit('showCheckOutPage', 'yes');
                        this.$store.dispatch('goToCheckout', sentData);
                        return;
                    }
                }
                sentData.availability_id = availability_id;
                sentData.pms_info = pms_info;
                sentData.pms_availability_error = pms_availability_error;
                sentData.pmsfa = pms_error;
                sentData.applicable_layouts = this.applicable_layouts;
                
                Vue.http.post(ajaxUrl, sentData).then(response => {
                    let data = response.body;
                    let url = baseUrl + lang + '/book-universal/' + data;
                    if(this.isRadisson){
                        url = baseUrl + '/book-universal/' + data;
                    }
                    // If booking.com here we set some cookies for the thank you page.
                    let site_url = window.location.host;
                    if(site_url == 'booking.meetingpackage.com' || site_url == 'meetingpackage.com' ){
                        let check_in_date = moment(this.$store.state.date, 'DD-MM-YYYY').format('YYYY-MM-DD');
                        let check_out_date = moment(check_in_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
                        let latlon = this.$store.state.venueInfo.latlon.split(',');
                        let latitude = latlon[0];
                        let longitude = latlon[1];
                        this.$cookie.set('bk_check_in_date', check_in_date);
                        this.$cookie.set('bk_check_out_date', check_out_date);
                        this.$cookie.set('bk_latitude', latitude);
                        this.$cookie.set('bk_longitude', longitude);
                    }

                    // Go to checkout page.
                    window.location.href = url;

                    }, response => {
                });
            }
        },
        createRegusBooking() {
            this.$store.commit('setProcessing', 'yes');
            let roomIF = [];
            let startD = this.$store.state.datetime;
            let startT = this.$store.state.time;
            let endD = moment(startD, 'DD-MM-YYYY HH:mm');
            let mt_length = '';
            let baseUrl = this.$store.state.baseUrl;

            let lang = this.$store.state.selectedLang;
            if(lang == 'en'){
            lang = '';
            } else {
            lang = '/' + lang;
            }

            if(this.$store.state.meeting_length == 'overnight'){
            mt_length = 24;
            } else if(this.$store.state.meeting_length == 'twodays'){
            mt_length = 36;
            } else {
            mt_length = parseInt(this.$store.state.meeting_length);
            }

            endD = endD.add(mt_length, 'hours');
            endD = endD.format('DD-MM-YYYY HH:mm');

            let roomList = this.$store.state.regusRoomInfo;
            roomList.forEach(element => {
            if(element.id == this.$store.state.selectedRegusRoom){
                roomIF['name'] = element.title;
                roomIF['code'] = element.id;
                roomIF['photo'] = element.room_pictures;
                roomIF['room_layout'] = element.room_layout;
                roomIF['room_price_no_vat'] = element.no_vat_price;
            }
            });

            let sentData = {
            'search_result_id' : roomIF['code'],
            'mt_length' : mt_length
            }

            Vue.http.post(baseUrl + '/apiv2/regus/temporarybook', sentData).then(response => {
                if(response.data){
                    let checkout_items = {
                    'startD' : startD,
                    'startT' : startT,
                    'endD' : endD,
                    'currency': this.$store.state.venueInfo.currency_code,
                    'currencySymbol' : this.$store.state.venueInfo.currency,
                    'room' : roomIF['name'],
                    'room_code' : roomIF['code'],
                    'delegates' : this.$store.state.delegates,
                    'layout' : roomIF['room_layout'],
                    'venue' : this.$store.state.venueInfo.title,
                    'venue_id': this.$store.state.venueInfo.id,
                    'roomPhoto' : roomIF['photo'],
                    'roomPrice_NoVAT' : roomIF['room_price_no_vat'],
                    'roomPrice' : this.$store.state.roomPrice,
                    'roomTotalPrice' : this.$store.state.roomTotalPrice,
                    'reservationID': response.data.temporaryReservationID,
                    //'services': response.data.services,
                    };

                    let services = response.data.services;

                    // Set Checkout Items cookie.

                    this.$cookie.set('checkout_items', JSON.stringify(checkout_items), { expires: '20m' });
                    localStorage.setItem('services', JSON.stringify(services));


                    // If booking.com here we set some cookies for the thank you page.
                    let site_url = window.location.host;
                    if(site_url == 'booking.meetingpackage.com' || site_url == 'meetingpackage.com'){
                    let check_in_date = moment(this.$store.state.date, 'DD-MM-YYYY').format('YYYY-MM-DD');
                    let check_out_date = moment(check_in_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
                    let latlon = this.$store.state.venueInfo.latlon.split(',');
                    let latitude = latlon[0];
                    let longitude = latlon[1];
                    this.$cookie.set('bk_check_in_date', check_in_date);
                    this.$cookie.set('bk_check_out_date', check_out_date);
                    this.$cookie.set('bk_latitude', latitude);
                    this.$cookie.set('bk_longitude', longitude);
                    }

                    if(this.$cookie.get('regus_cart_expiration')){
                    this.$cookie.delete('regus_cart_expiration');
                    }

                    // Redirect to Regus Checkout page.
                    let url = '';
                    url = baseUrl + lang + '/book'
                    window.location.href = url;

                } else {
                    alert('There is error while processing your order. Please reload the page.');
                }
            });
        },
        createPackageBooking(event, packageID) {
          this.setSelectedPackage(packageID)
          this.create(event, true)
        },
        isCapacityReduced(layout) {
            return parseInt(this.roomLayoutOriginal[layout]) > parseInt(this.roomLayout[layout])
        },
        packageHasReducedPrice(correct_price) {
            if(window.location.hostname === 'interikea.cwteasymeetings.com'){
                return false;
            }

            // totalPriceInPriceDetails = price + minumum_spent
            if (correct_price?.price > 0) {
                return correct_price?.original_price > correct_price?.price && correct_price?.show_strike_through                               
            } else {
                // Check original price
                if (correct_price?.original_price > 0)
                    return correct_price?.price_category === 'disc_price' && correct_price?.show_strike_through
                return false
            }

            // return correct_price?.original_price > correct_price?.price && correct_price?.show_strike_through
        },
        isPackageDetailsOpened(packageID) {
            return this.packageDetailsOpened.includes(packageID)
        },
        togglePackageDetails(packageID) {
            let packageIDIndex = this.packageDetailsOpened.indexOf(packageID)

            if (packageIDIndex > -1) {
                this.packageDetailsOpened.splice(packageIDIndex, 1);
            } else {
                this.packageDetailsOpened.push(packageID)
            }
        },
        isPriceDetailsOpened(packageID) {
            return this.priceDetailsOpened.includes(packageID)
        },
        clearPriceDetailOpened() {
            this.priceDetailsOpened = []
        },
        togglePriceDetails(packageID) {
            let packageIDIndex = this.priceDetailsOpened.indexOf(packageID)

            if (packageIDIndex > -1) {
                this.priceDetailsOpened.splice(packageIDIndex, 1);
            } else {
                this.priceDetailsOpened = []
                this.priceDetailsOpened.push(packageID)
            }
        },
        packageTotalOriginalPrice(packageObj) {
            let packageMin;
            if(this.isMoreThanOneDay){
                // Get the event list.
                let operaEventList = this.operaEventList;
                operaEventList.forEach(event => {
                    if(parseInt(event.day) == parseInt(this.day)){
                        packageMin = parseInt(event.delegates) > parseInt(packageObj.package_min) ? parseInt(event.delegates) : parseInt(packageObj.package_min);
                    }
                });
            } else {
                packageMin = this.getPackageCalculatedPriceDelegate(packageObj.package_min)
            }
            return packageObj.correct_price.original_price * packageMin;
        },
        packageTotalPrice(packageObj, isVATExclPrice){
            
            // Flag for delphi to overwrite frontend price calculation
            if (packageObj.correct_price.backend_price == true && !isVATExclPrice) {
                return packageObj.correct_price.total_price
            }

            if (packageObj.correct_price.backend_price == true && isVATExclPrice) {
                return packageObj.correct_price.total_price_no_vat
            }

            let packageMin;

            if(this.isMoreThanOneDay){
                // Get the event list.
                let operaEventList = this.operaEventList;
                operaEventList.forEach(event => {
                    if(parseInt(event.day) == parseInt(this.day)){
                        packageMin = parseInt(event.delegates) > parseInt(packageObj.package_min) ? parseInt(event.delegates) : parseInt(packageObj.package_min);
                    }
                });
            } else {
                packageMin = this.getPackageCalculatedPriceDelegate(packageObj.package_min)
            }
            let priceToUse
            if (isVATExclPrice)
                priceToUse = packageObj.correct_price.price_excl_vat !== 0 ? packageObj.correct_price.price_excl_vat : packageObj.correct_price.price
            else
                priceToUse = packageObj.correct_price.price

            return priceToUse * packageMin;
        },
        displayPackageDiscountAmount(packageObj) {
            if (packageObj.correct_price?.original_price < packageObj.correct_price?.price) {
                return null
            }
            return ((packageObj.correct_price?.original_price - packageObj.correct_price?.price) / packageObj.correct_price?.original_price * 100).toFixed(0) + "% " + this.strings.off
        },
        showRatesFilterCheck(filter) {
            if (this.showRatesFilter === 'all') {
                return true
            } else {
                return this.showRatesFilter === filter ? true : false
            }
        },
        setSelectedPackage(packageID, day){
            if(this.isMoreThanOneDay){
                this.$store.commit('setSelectedPackageForDay', {
                    'packageID' : packageID,
                    'day' : day
                });
            } else {
                this.$store.commit('setSelectedPackage', packageID);
                this.$store.state.packageInfo.forEach(element => {
                    if(element.id == packageID) {
                        this.$store.dispatch('sortRoomListinPackage', element.rooms);
                    }
                });
                this.$store.commit('changeSelectedPricePackage', packageID);
            }
        },
        getDEPrice(price) {
            if(price){
                if (this.$store.state.selectedLang === 'de') {
                  return price.toString().replace('.', ',')
                }
                return price
            }
        },
        getPackageMinimumDelegate(packageMin) {
            return parseInt(this.roomMin) < parseInt(packageMin) ? parseInt(packageMin) : parseInt(this.roomMin)
        },
        getPackageCalculatedPriceDelegate(packageMin) {
          let correctMinimumDelegates = parseInt(this.roomMin) < parseInt(packageMin) ? parseInt(packageMin) : parseInt(this.roomMin)

          return correctMinimumDelegates > this.s_delegates ? correctMinimumDelegates : this.s_delegates
        },
        getTranslations(data) {
            if (typeof data === 'string') {
                return data
            } else {
                return data[this.selectedLang] ? data[this.selectedLang] : data.en
            }
        },
        isPackageEnquiry(correct_price) {
            if (correct_price?.price > 0) {
                return false;
            } else {
                if (correct_price?.original_price > 0 && correct_price?.price_category === 'disc_price')
                    return false;
                else
                    return true;
            }
        }
    },
    computed: {
        applicable_layouts() {
            const delegates = this.$store.state.delegates;
            const layoutCodeMap = {
                banquet: 399,
                boardroom: 400,
                cabaret: 401,
                classroom: 402,
                cocktail: 403,
                island: 760,
                theater: 404,
                ushape: 405
            }
            // we hardcore remove island and cabaret from NCH
            return Object.entries(this.roomLayout).filter(entry => {
                const value = Number(entry[1])
                return value > 0 && value >= delegates
            }).map(entry => ({
                name: entry[0],
                code: layoutCodeMap[entry[0]],
                value: Number(entry[1]),
                originalValue: Number(this.roomLayoutOriginal[entry[0]])
            }))
        },
        roomRentalPrice() {
            let price = 0
            if (!this.isRegus) {
                switch (this.chosenPriceType) {
                    case 'normal':
                    case 'hourly':
                        if (!this.notNumericMT) {
                            if (!this.isSmartSpace)
                                price = this.correctPrice.price * parseInt(this.meetingLength) / 100
                            else
                                price = this.correctPrice.price
                            }
                        break;
                    case 'halfday':
                    case 'fullday':
                        if (!this.notNumericMT)
                        price = this.correctPrice.price / 100
                        break;
                    case 'opera':
                        price = this.correctPrice.price / 100
                        break;
                    case 'none':
                        price = '0.00'
                        break;
                    default:
                        if (this.chosenPriceType != 'opera' && this.notNumericMT)
                        price = '0.00'
                }
            } else {
                price = this.correctPrice.price / 100
            }

            return price
        },
        minimumSpend() {
            if (this.correctPrice.minimum_spend) {
                return this.correctPrice.minimum_spend / 100
            }
            return 0
        },
        isLoading() {
            return !this.$store.state.roomsReady;
        },
        totalPriceInPriceDetails() {
            let price = 0
            if (!this.isRegus) {
                switch (this.chosenPriceType) {
                    case 'normal':
                    case 'hourly':
                        if (!this.notNumericMT) {
                            if (!this.isSmartSpace)
                                price = this.correctPrice.price * parseInt(this.meetingLength) / 100
                            else
                                price = this.correctPrice.price
                            }
                        break;
                    case 'halfday':
                    case 'fullday':
                        if (!this.notNumericMT)
                        price = this.correctPrice.price / 100
                        break;
                    case 'opera':
                        price = this.correctPrice.price / 100
                        break;
                    case 'none':
                        price = '0.00'
                        break;
                    default:
                        if (this.chosenPriceType != 'opera' && this.notNumericMT)
                        price = '0.00'
                }
            } else {
                price = this.correctPrice.price / 100
            }

            return this.getDEPrice((price + this.minimumSpend).toFixed(2))
        },
        roomRentalPriceExclVAT() {
            let price = ''

            if (!this.notNumericMT) {
                if (this.correctPrice.type == "hourly")
                    price = this.correctPrice.price_excl_vat * parseInt(this.meetingLength) / 100
                else
                    price = this.correctPrice.price_excl_vat / 100
            } else {
                price = '0.00'
            }

            return price
        },
        isDavinci() {
            return window.isDavinci
        },
        isRegus() {
            return this.$store.state.isRegus;
        },
        showEstimatedLocalPrice() {
            if (this.isDavinci && this.$store.state.venueInfo.local_currency_code && (this.$store.state.venueInfo.currency_code !== this.$store.state.venueInfo.local_currency_code)) {
                return true
            }
            return false
        },
        roomPriceOriginal(){
            if(this.correctPrice && this.correctPrice.original_price){
                return this.correctPrice.original_price;
            }
            return 0;

        },
        correctOriginalPrice() {
            let totalOriginalPrice = this.roomPriceOriginal * (this.chosenPriceType == 'normal' || this.chosenPriceType == 'hourly' ? parseInt(this.meetingLength): 1 ) / 100
            if (this.correctPrice.original_minimum_spend) {
                totalOriginalPrice +=  this.correctPrice.original_minimum_spend / 100
            }
            return totalOriginalPrice
        },
        showDetailsToggle(){
            return (this.$store.state.layouts && this.$store.state.layouts.length > 0) ||  (this.roomDescriptionTranslated) || this.roomHasDimension || this.roomEquipment?.length > 0 || this.roomEquipmentFee?.length > 0;
        },
        displayDiscountAmount(){
            return 100 - (Number(this.totalPriceInPriceDetails) / Number(this.correctOriginalPrice) * 100).toFixed(0) + "% " + this.strings.off;
        },
        isRadisson(){
            return window.isRadisson == '1' ? true : false
        },
        hasReducedPrice() {
            let priceIsDiscounted = false;
            if(window.location.hostname === 'interikea.cwteasymeetings.com'){
                return priceIsDiscounted;
            }

            // totalPriceInPriceDetails = price + minumum_spent
            if (Number(this.totalPriceInPriceDetails) > 0) {
                return (this.totalPriceInPriceDetails < this.correctOriginalPrice) && this.correctPrice.show_strike_through                               
            } else {
                // Check original price
                if (Number(this.correctOriginalPrice) > 0)
                    return this.correctPrice.price_category === 'disc_price' && this.correctPrice.show_strike_through
                return false
            }
        },
        isInstantBooking(){
            return this.instantBookable == '1' && !(this.available == 0 || this.exceed == 'yes' || !this.valid_layout)
        },
        roomHasDimension(){
            return this.roomArea > 0 || this.roomHeight > 0 || this.roomWidth > 0 || this.roomLength > 0
        },
        isClosed(){
            return this.$store.state.isClosed;
        },
        isOutsideBusinessHours(){
            return this.$store.state.isOutsideBusinessHours;
        },
        eventList() {
            return this.$store.state.eventList;
        },
        isMoreThanOneDay() {
            return this.$store.state.isMoreThanOneDay;
        },
        isBE(){
            return this.$store.state.isBE;
        },
        useNewCheckoutPage(){
            return this.$store.state.useNewCheckoutPage;
        },
        isNCH(){
            return this.$store.state.isNCH;
        },
        isOpera() {
            return this.$store.state.isOpera;
        },
        isHanselWL() {
            return this.$store.state.isHanselWL;
        },
        currencySymbol(){
            return this.$store.state.currencySymbol;
        },
        roomPackagePrice(){
            let delegates = this.$store.state.delegates > parseInt(this.roomMin) ? this.$store.state.delegates: parseInt(this.roomMin);
            return  parseFloat(this.roomPriceVat * delegates).toFixed(2);
        },
        currentTab() {
            if (this.$store.state.isTranslated) {
                this.$store.dispatch('gTranslateRoom', { text: this.roomDescription, lang: this.$store.state.selectedLang }).then((data)=>{
                this.roomDescriptionTranslated = data;
                });
            } else {
                this.roomDescriptionTranslated = this.roomDescription;
            }
            return this.$store.state.currentTab;
        },
        notNumericMT() {
            let mt_length = this.$store.state.meeting_length;
            if(mt_length == 'overnight' || mt_length == 'twodays'){
                return true;
            } else {
                return false;
            }
        },
        activeTranslate() {
            return this.$store.state.isTranslated;
        },
        selectedLang () {
            return this.$store.state.selectedLang;
        },
        toggleDetail() {
          return this.$store.state.toggleDetailId;
        },
        strings () {
  	        return this.$store.state.strings
        },
        checkImage() {
            if(this.image == '') {
                return true;
            }
            else {
                return false
            }
        },
        meetingLength() {
            if(this.isMoreThanOneDay){
                return this.mt_length;
            } else {
                return this.$store.state.meeting_length;
            }
        },
        discountCode() {
            return this.$store.state.discount_code
        },
        discPriceErrorShouldShow() {
            return this.$store.state.discPriceErrorShouldShow;
        },
        roomPackages() {
            if (this.isRegus)
                return []
            let delegates = this.$store.state.delegates
            let packageInfo = JSON.parse(JSON.stringify(this.$store.state.packageInfo))
            let packages = packageInfo.filter(packageItem => {
                let packageLengthCheck = false
                let roomCheck = packageItem.rooms.find(room => {
                    return room.id === this.id
                })

                // New package minimum delegates logic
                if (roomCheck) {
                    const minDelegateToCheck = parseInt(this.roomMin) < parseInt(packageItem.package_min) ? parseInt(packageItem.package_min) : parseInt(this.roomMin)
                    const maxDelegateToCheck = parseInt(this.roomMax) > parseInt(packageItem.package_max) ? parseInt(packageItem.package_max) : parseInt(this.roomMax)

                    if (parseInt(this.s_delegates) < minDelegateToCheck || parseInt(this.s_delegates) > maxDelegateToCheck) {
                        return false
                    }
                }

                if (roomCheck && (packageItem.is_new || this.isOpera)) { // New packages
                    // We need to get the package_correct_price for the room
                    // Check if roomCheck has package_correct_price, if not then assign null to packageItem.correct_price to avoid error
                    if (roomCheck.package_correct_price) {
                        packageItem.correct_price = roomCheck.package_correct_price
                    }

                    return roomCheck
                } else { // Old packages
                    switch (packageItem.type) {
                        case 'Half-day package':
                            packageLengthCheck = this.s_meetingLength < 6 ? true : false
                            break
                        case 'Full-day package':
                            packageLengthCheck = this.s_meetingLength < 10 ? true : false
                            break
                        case 'Overnight package':
                            packageLengthCheck = this.s_meetingLength === 'overnight' ? true : false
                            break
                        case 'Two-days package':
                            packageLengthCheck = this.s_meetingLength === 'twodays' ? true : false
                            break
                        default:
                            packageLengthCheck = false
                            break
                    }
                    return roomCheck && packageLengthCheck
                }
            })

            // If there is a valid discount code applied, only show packages that have discount
            if (this.discountCode && !this.discPriceErrorShouldShow) {
                packages = packages.filter(packageItem => packageItem.correct_price.price_category === "disc_price")
            }

            this.roomPackageCount = packages.length
            // We need to sort the packages by price
            let packagesList = _.orderBy(
                packages,
                [
                    function (item) {
                        // Sort by whether package is exceeded in delegates or not
                        return item.exceed == 'yes' ? 1 : 0
                    },
                    function (item) {
                        // Sort by whether package has discount or not
                        return item.correct_price.price_category === 'disc_price' ? 1 : 0
                    },
                    function (item) {
                        // Sort by price.
                        var correctDelegates =
                            parseInt(item.package_min) > parseInt(delegates)
                                ? parseInt(item.package_min)
                                : parseInt(delegates)
                        if (item.correct_price.correct_delegates) {
                            correctDelegates = item.correct_price.correct_delegates
                        }
                        return (
                            parseInt(item.correct_price.price) * correctDelegates ||
                            Infinity
                        )
                    }
                ],
                ['asc', 'desc', 'asc']
            )
            if (this.isShowAllPackages) {
                return packagesList
            } else {
                return packagesList.slice(0, 2)
            }
        },
        showRatesFilter() {
            return this.$store.state.showRatesFilter
        },
        s_meetingLength() {
            return this.$store.state.meeting_length
        },
        s_delegates() {
          return this.$store.state.delegates;
        },
        davinciLocalTotalPrice() {
            let orignalTotalPrice = parseFloat(this.roomRentalPrice) ? parseFloat(this.roomRentalPrice) : 0
            let result = (orignalTotalPrice * this.$store.state.venueInfo.local_currency_conversion_rate).toFixed(2)
            return result
        },
        localCurrencyCode (){
            return this.$store.state.venueInfo.local_currency_code;
        },
        roomAllEquipment() {
            return this.$store.state.allEquipment
        },
        isShowRoomRentalWebBookable() {
            if (this.showRatesFilter != 'packages') {
                return this.isWebBookable
            }
        },
        isMeetingRoomVisible() {
            const invalidRoom = this.available == 0 || this.exceed == 'yes' || !this.valid_layout
            const hasPackageCheck = this.roomPackages.length > 0
            const hasRoomRentalCheck = this.isRoomDiscounted
            let showRateFilterCheck = true

            if (this.showRatesFilter == 'roomRental') {
                showRateFilterCheck = this.isWebBookable && hasRoomRentalCheck
            } else if (this.showRatesFilter == 'packages') {
                showRateFilterCheck = this.roomPackages.length > 0
            } else { // "All" case
                if (hasPackageCheck) {
                    showRateFilterCheck = true
                }
                else {
                    showRateFilterCheck = this.isWebBookable && (hasPackageCheck || hasRoomRentalCheck)
                }
            }

            return !invalidRoom && showRateFilterCheck
        },
        isRoomDiscounted() {
            if (this.discountCode && !this.discPriceErrorShouldShow) {
                return this.correctPrice?.price_category === "disc_price" ? true : false
            }
            return true
        },
        fkDelegatesErrorShouldShow() {
            return this.$store.state.fkDelegatesErrorShouldShow
        }
    },
    watch: {
        toggleDetail() {
          if(this.id == this.$store.state.toggleDetailId) {
              this.isHidden = !this.isHidden;
              this.$store.commit('toggleDetailId', '');
          }
        },
        activeTranslate() {
            if (this.$store.state.isTranslated) {
                this.$store.dispatch('gTranslateRoom', { text: this.roomDescription, lang: this.$store.state.selectedLang }).then((data)=>{
                this.roomDescriptionTranslated = data;
                });
            } else {
                this.roomDescriptionTranslated = this.roomDescription;
            }
        },
        selectedLang() {
            if (this.$store.state.isTranslated) {
                this.$store.dispatch('gTranslateRoom', { text: this.roomDescription, lang: this.$store.state.selectedLang }).then((data)=>{
                this.roomDescriptionTranslated = data;
                });
            } else {
                this.roomDescriptionTranslated = this.roomDescription;
            }
        },
        correctPrice(newCorrectPrice) {
            const minimumSpend = newCorrectPrice.minimum_spend ? newCorrectPrice.minimum_spend : 0

            if (parseInt(newCorrectPrice.price + minimumSpend) > 0) {
                this.isEnquiry = false;
            } else {
                if (newCorrectPrice.original_price > 0 && newCorrectPrice.price_category === 'disc_price')
                    this.isEnquiry = false;
                else
                    this.isEnquiry = true;
            }
        },
        roomDescription(newDesc) {
            this.roomDescriptionTranslated = newDesc
        }
    },
    mounted() {
        let vueThis = this

        let minimumSpend = this.correctPrice.minimum_spend ? this.correctPrice.minimum_spend : 0

        if (parseInt(this.correctPrice.price + minimumSpend) > 0) {
            this.isEnquiry = false;
        } else {
            if (this.correctPrice.original_price > 0 && this.correctPrice.price_category === 'disc_price')
                this.isEnquiry = false;
            else
                this.isEnquiry = true;
        }

        $(document).on('mouseup',function(e) {
            var container = $(document).find(".price__item-price-help-text")

            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0)
            {
                vueThis.clearPriceDetailOpened()
            }
        })
    }
}
</script>

<style scoped>

.event_item_list {
    margin-left: 34px;
    margin-bottom: 10px;
}

.radio__item.isBE {
    background: #fff;
    margin: 20px 0 20px 0;
}

button {
    outline: none;
}

.no-border-bottom {
    border-bottom: none;
}

.new_seating_order{
    display: none;
}

.radio_head__be {
    flex: 0 3 70% !important;
}
.radio_head__be ul, .radio__single-detail ul{
   padding-left: 0px;
}
.radio__title{
    margin-top:0px;
}
.isBE .new_seating_order ul {
    flex-wrap: wrap !important;
}

.isBE .new_seating_order ul li {
    flex: none !important;
    margin-bottom: 5px !important;
}

.isBE .new_seating_order ul li img {
    width: 20px;
    height: auto;
}

.isBE .radio__content {
    border-left: none !important;
    cursor: inherit !important;
}

.isBE .radio__content:after, .isBE .radio__content:before {
    content: none !important;
}

.radio .isBE input[type=radio]:checked+.radio__content {
    background-color: white;
    box-shadow: inset 0 0 0 1px #e0e0e0;
}
.radio_head_disabled{
    flex: 0 1 70%!important;
 }
 .radio__pricing_disabled .radio__price, .radio__pricing_disabled .radio__audience, .radio__pricing_disabled .ribbon, .radio__pricing_disabled .radio__audience, .radio__pricing_disabled  .radio__audience, .radio_head_disabled, .new_seating_order_disabled{
     opacity: 0.4;
 }
 .radio__pricing_disabled .checklist__item--attention, .roomitemList .checklist__item--attention{
     background:none;
     padding:0px;
 }
 .attentionImage{
    border: none;
    width: 15px;
    height: 15px;
    vertical-align: bottom;
    display: block;
    margin-bottom: 5px;
 }
@media (min-width: 639px){
    .isBE .radio__carousel {
        width: 400px;
        height: 200px;
        cursor: pointer;
    }

    .new_seating_order{
        display: block;
        width: 64%;
    }

}
.isBE .radio_head_disabled{
    flex: 0 3 70%!important;
}

.isBE .new_seating_order .seating-list__item.seating-list__item--not-available {
    display: none;
}

.top_equipments-item {
    float: none;
    width: 100%;
}

.seating_order-title {
    text-align: left;
    margin-bottom: 0px;
}

.seating-list__item {
    padding: 10px 12px;
    height: 100%;
}

.dimension-title {
    text-align: left;
    border: none;
    margin-top: 10px;
    margin-bottom: 0px;
}

.dimension-list {
    list-style-type: none;
    font-size: 14px;
    text-align: right;
    display: flex;
    align-items: flex-end;
}

.dimension-list li {
    display: block;
    cursor: pointer;
    text-align: center;
    padding: 10px 12px;
    border: 1px solid #E0E0E0;
    border-radius: 5px;
    background-color: white;
    margin-right: .3em;
    height: 60px;
}

.dimension-list-icon {
    width: 20px;
    height: 20px;
    color: #051223;
}

.collapse-trigger-icon {
    width: 12px;
    height: 12px;
    color: #0041d1;
    margin-left: 3px;
}

.package-rates-collapse-icon {
    width: 10px;
    height: 10px;
    color: #505050;
    margin-left: 3px;
}

.divider {
    margin: 10px 0;
    height: 1px;
    background-color: #e0e0e0;
}

.showmore-divider {
    margin-top: 10px;
    height: 1px;
    background-color: #e0e0e0;
    position: relative;
}

.showmore-text {
    text-align: center;
    position: absolute;
    left: calc(50% - 60px);
    background: white;
    top: -7px;
    font-size: 12px;
    width: 120px;
}

.showmore-text:hover {
    cursor: pointer;
}

.package__list-container {
    margin-top: 30px;
}

.price__item-disabled {
    opacity: 0.4;
}

.price__item-container {
    padding: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
}

.price__item-description {
    display: block;
    width: 40%;
    margin-right: auto;
}

.price__item-title {
    font-size: 20px;
    font-weight: bold;
    color: #323232;
}

.price__item-delegate-size {
    font-size: 12px;
}

.price__item-subtitle {
    font-size: 14px;
    color: #0041d1;
    font-weight: normal;
    margin-top: 10px;
}

.price__item-subtitle:hover {
    cursor: pointer;
}

.price__item-price {
    text-align: right;
    margin-right: 20px;
}

.price__item-price.is_item_seasonal {
    margin-top: 20px;
    position: relative;
}

.price__item-price .radio__price {
    font-size: 20px;
}

.price__item-price .radio__price.original_price {
    text-align: right;
    margin-right: 5px;
    font-size: 20px;
    font-weight: bold;
    display: inline;
}

.price__item-price .radio__price {
    text-align: right;
    font-size: 20px;
    font-weight: bold;
    display: inline;
}

.price__item-price .price__item-price-help-text {
    font-size: 14px;
    font-weight: normal;
    margin-top: 3px;
    color: #0041D1;
    position: relative;
    text-align: right;
    display: block;
}

.price__item-price .price__item-price-help-text:hover {
    cursor: pointer;
}

.price__item-price.package__items .radio__price.package_personal_price {
    margin-right: 5px;
}

.price__item-price.package__items .radio__audience {
    display: inline;
}

.price__item-price.package__items .aside__total_be {
    display: inline;
}

.price__item-price.package__items .is_package_total_price {
    margin-right: 0;
    font-weight: bold;
}

.price__item-cta {
    margin: 0;
    min-width: 130px;
    max-width: 160px;
    font-weight: normal;
    text-transform: uppercase;
}

.price__item-cta:hover {
    cursor: pointer;
}

.price__item-details {
    margin-top: 10px
}

.price__item-details-content-list {
    margin-top: 10px;
}

.price__item-details-content-item {
    font-size: 14px;
}

.price__item-details-content {
    width: 100%;
}

.price__item-details-description {
    font-size: 14px;
}

.price__item-price-detail-container {
    position: absolute;
    width: 350px;
    right: -10px;
    top: 20px;
    box-shadow: 0 0.5rem 1rem 0 rgb(0 11 38 / 24%);
    padding: 10px;
    background-color: white;
    color: #505050;
    z-index: 1;
    border-radius: 5px;
}
.price__item-price-detail-title {
    font-size: 16px;
    text-align: left;
    font-weight: bold;
    margin-bottom: 10px;
}
.price__item-price-detail-list {
    margin-top: 10px;
}
.price__item-price-detail-item {
    display: flex;
    padding: 3px 0;
}
.price__item-price-detail-item-name {
    margin-right: auto;
}
.price__item-price-detail-item-total {
    display: flex;
    padding: 3px 0;
    margin-bottom: 10px;
    font-weight: bold;
}
.price__item-price-detail-warning-message {
    text-align: left;
    color: #505050 !important;
}

.price__item-price-detail-warning-message strong {
    color: #FF0000 !important;
}

.price_item-unavailable-message.checklist {
    max-width: 130px;
}
.price_item-unavailable-message.checklist li {
    padding: 0;
    margin: 0;
}
.radio__price.savings{
  text-decoration: none;
  font-size: 12px !important;
  position: absolute;
  top: -25px;
  right: 0px;
  background-color: #0056a8;
  color: white;
  padding: 3px 5px;
  border-radius: 3px;
  font-weight: bold;
}
.radio__price.include_vat_text {
  font-size: 14px;
  font-weight: normal;
}

.equipmentList {
    margin-top: 12px;
}

@media(max-width:638px){
    .ribbon {
        display: block;
    }
    button.book-now{
        margin-left: auto;
    }
    .price__item-description {
        width: 100%;
        margin-bottom: 20px;
    }
    .price__item-price .radio__price.savings {
        left: 0px;
        right: unset;
        min-width: unset;
    }
    .price__item-price .price__item-price-help-text {
        text-align: left;
    }
    .price__item-price .radio__price {
        float: left;
        text-align: left;
        min-width: 62px;
        margin-bottom: 0px;
    }
    .price__item-price .radio__price.original_price {
        text-align: left;
    }
    .price__item-price-detail-container {
        left: -10px;
        top: 50px;
        right: unset;
    }
}

@media(max-width: 376px) {
    .price__item-price {
        margin-bottom: 15px;
    }
    .price__item-cta {
        width: 100%;
    }
}

</style>

<style>
  .video__container_360 iframe {
    width: 100%!important;
    position: inherit!important;
    top: 0px!important;
    height: 100%!important;
  }
   .video__container_360 .modal-body  {
    margin: 0px!important;
    height: 400px!important;
  }
   .video__container_360{
    height: 100%;
  }
  .video__container_360 .modal-container{
    width: 800px;
    height:485px!important;
  }
  @media screen and (max-width: 830px) {
    .video__container_360 .modal-container{
      width: 100%!important;
    }
  }
   .video__container_360 .modal-body  {
     margin: 0px!important;
    height: 400px!important;
  }
  .video__container_360{
    height: 100%;
  }
  .video__container_360 .vue-lb-button-close{
    top:10px!important;
    margin-bottom: 0px!important;
  }
  .video__container_360 .modal-container{
    width: 800px;
    height:485px!important;
  }

  .video__container_360 .modal-wrapper, .video__container_360 .modal-body{
      height:100%!important;
  }
  .video__container_360 .modal-body{
      margin-top: 0px!important;
      padding: 0px!important;
      margin-bottom: 15px!important;
  }
  .video__container_360 .modal-container{
    height: 550px!important;
    width: 800px!important;
    padding:0px!important
  }
 .video__container_360 .modal-header{
        display:none!important;
  }
   .video__container_360 .modal-footer{
        border-top: none!important;
  }
  .threesixtyLink{
    display: block!important;
    margin-bottom: 0px;
    cursor: pointer;
    color: #333;
    text-decoration-color: rgb(51, 122, 183);
    margin-top: 5px!important;
    text-decoration: underline;
  }
  .threesixtyLink::hover{
    color: rgb(51, 122, 183);
  }
  .video__container_360 .modal-body iframe {
    width: 100%!important;
    height: 550px!important;
      }
  .video360ModalBody{
    height:100%!important;
  }
  .video__container_360 .modal-container{
      background:transparent!important;
  }
  .isNCH .threeSixtyCloseBtn{
      background-color: #00aa50!important;
  }
  .isNCH .radio__pricing .radio__audience{
          font-size: 12px;
  }
    @media screen and (max-width: 830px) {
    .video__container_360 .modal-container{
      width: 400px!important;
      max-width: 400px!important;
    }
  }
   @media screen and (min-width: 1200px) {
    .isNCH .new_seating_order{
      width: 35%!important;
      max-width: 300px;
    }
  }
  .is_seasonal{
      font-weight: 400;
  }
  .original_price{
      color: #333 !important;
      font-weight: 400;
      text-decoration: line-through;
      margin-bottom:0px!important;
  }
  .original_price svg{
    padding-top: 3px;
    padding-bottom: 2px;
    color: black;
    font-weight: 400;
  }
  .savings{
    text-decoration: none;
    font-size: 12px;
    margin-bottom: 5px;
    font-size: 12px!important;
    font-weight: 400;
  }
  .seating-list-capacity {
    display: flex;
    justify-content: center;
  }
  .seating-list-capacity .seating-list__count-original {
    text-decoration: line-through;
  }
  .seating-list-capacity .seating-list__count-reduced {
    color: darkred;
    margin-left: 5px;
  }
</style>
